import React, { useState, useEffect, useRef, useMemo } from "react";
import { getDocs, doc, getDoc, collection, updateDoc, onSnapshot, query, where, runTransaction, collectionGroup } from "firebase/firestore";
import { setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import DateRangePopup from "../../components/DateRangePopup";
import { useLocation } from 'react-router-dom';
import { useCountry } from './../CountryContext';
import ReportsSection from "../../components/ReportDropdown8"
import Chart from "../../components/Chart";
import { motion, AnimatePresence } from "framer-motion";
import ChartMobile from "../../components/ChartMobile";
import { Link } from "react-router-dom";
const Dropdown = ({ type, value, options, onSelect, countryValue }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownMenuRef = useRef(null);
  const contentRef = useRef(null);
  const thumbRef = useRef(null);
  const [thumbHeight, setThumbHeight] = useState(20);
  const [scrollTop, setScrollTop] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});

  // Define all possible options
  const allOptions = {
     
      CROPS: [
          { id: "african-night-shade", name: "African Night Shade", value: "african-night-shade" },
          { id: "alovera", name: "Alovera", value: "alovera" },
          { id: "avocados", name: "Avocados", value: "avocados" },
          { id: "apple", name: "Apple", value: "apple" },
          { id: "bananas", name: "Bananas", value: "bananas" },
          { id: "baobab", name: "Baobab", value: "baobab" },
          { id: "beans", name: "Beans", value: "beans" },
          { id: "beetroot", name: "Beetroot", value: "beetroot" },
          { id: "black-nightshade", name: "Black Nightshade", value: "black-nightshade" },
          { id: "cabbage", name: "Cabbage", value: "cabbage" },
          { id: "capsicum", name: "Capsicum", value: "capsicum" }
      ],
      LIVESTOCK: [
          { id: "bees", name: "Bees", value: "bees" },
          { id: "cattle-dairy", name: "Cattle - Dairy", value: "cattle-dairy" },
          { id: "fish", name: "Fish", value: "fish" },
          { id: "catfish", name: "Catfish", value: "catfish" }
      ],
      FOREST: [
          { id: "bamboo", name: "Bamboo", value: "bamboo" },
          { id: "blue-gum", name: "Blue Gum", value: "blue-gum" }
      ]
  };

  // Get the correct options based on dropdown type
  const dropdownOptions = allOptions[type] || options || [];

  const capitalizeWords = (str) => {
      if (!str) return "";
      return str
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(" ");
  };

  const getDisplayValue = () => {
      if (value) {
          if (type === "COUNTRY") return value.name || "-";
          return value.name || value.value || "-";
      }
      return "-";
  };

  const getHeaderTitle = () => {
      switch (type) {
          case "COUNTRY":
              return "Countries";
          case "REGION":
              return "Regions";
          case "DISTRICT":
              return "Districts";
          case "MUNICIPALITY":
              return "Municipalities";
          case "SMMEs":
              return "SMMEs";
          case "VALUE CHAIN":
              return "Value Chains";
          case "PROJECT":
              return "Projects";
          case "USER TYPE":
              return "User Types";
          case "SERVICES":
              return "Services";
          case "CROPS":
              return "Crops";
          case "LIVESTOCK":
              return "Livestock";
          case "FOREST":
              return "Forest";
          default:
              return "Select Option";
      }
  };

  const toggleItemSelection = (itemId) => {
      setSelectedItems(prev => ({
          ...prev,
          [itemId]: !prev[itemId]
      }));
  };

  const renderRegularItems = () => {
      return dropdownOptions?.map((option, index) => (
          <li
              key={index}
              className={`group flex items-center justify-between px-3 py-2 text-sm cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                  selectedItems[option.id] ? "bg-[#2E453D]" : ""
              }`}
          >
              <span 
                  className="text-white"
                  onClick={(e) => {
                      e.stopPropagation();
                      onSelect(option);
                      setIsOpen(false);
                  }}
              >
                  {option.name || option.value}
              </span>
              <button 
                  onClick={(e) => {
                      e.stopPropagation();
                      toggleItemSelection(option.id);
                  }}
              >
                  {selectedItems[option.id] ? <SelectedIcon /> : <UnselectedIcon />}
              </button>
          </li>
      ));
  };

  const renderGroupedItems = () => {
    return (
      <div className="mb-2">
        {/* Always show all sections */}
        <h4 className="text-white font-bold px-3 py-1 bg-[#2E453D]/50">CROPS</h4>
        <ul>
          {allOptions.CROPS.map((item, index) => (
            <li
              key={`crop-${index}`}
              className={`group flex items-center justify-between px-3 py-2 text-sm text-white cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                selectedItems[item.id] ? "bg-[#2E453D]" : ""
              }`}
            >
              <span 
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect(item);
                  setIsOpen(false);
                }}
              >
                {item.name}
              </span>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  toggleItemSelection(item.id);
                }}
              >
                {selectedItems[item.id] ? <SelectedIcon /> : <UnselectedIcon />}
              </button>
            </li>
          ))}
        </ul>
  
        <h4 className="text-white font-bold px-3 py-1 bg-[#2E453D]/50 mt-2">LIVESTOCK</h4>
        <ul>
          {allOptions.LIVESTOCK.map((item, index) => (
            <li
              key={`livestock-${index}`}
              className={`group flex items-center justify-between px-3 py-2 text-sm text-white cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                selectedItems[item.id] ? "bg-[#2E453D]" : ""
              }`}
            >
              <span 
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect(item);
                  setIsOpen(false);
                }}
              >
                {item.name}
              </span>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  toggleItemSelection(item.id);
                }}
              >
                {selectedItems[item.id] ? <SelectedIcon /> : <UnselectedIcon />}
              </button>
            </li>
          ))}
        </ul>
  
        <h4 className="text-white font-bold px-3 py-1 bg-[#2E453D]/50 mt-2">FOREST</h4>
        <ul>
          {allOptions.FOREST.map((item, index) => (
            <li
              key={`forest-${index}`}
              className={`group flex items-center justify-between px-3 py-2 text-sm text-white cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                selectedItems[item.id] ? "bg-[#2E453D]" : ""
              }`}
            >
              <span 
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect(item);
                  setIsOpen(false);
                }}
              >
                {item.name}
              </span>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  toggleItemSelection(item.id);
                }}
              >
                {selectedItems[item.id] ? <SelectedIcon /> : <UnselectedIcon />}
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const UnselectedIcon = () => (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8.5" cy="8.5" r="8" fill="#D9D9D9" stroke="none"/>
    </svg>
  );
  
  const SelectedIcon = () => (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8.5" cy="8.5" r="8" fill="#2E453D" stroke="#FFBD26"/>
      <path d="M5 8.5L7.5 11L12 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  const handleScroll = () => {
    if (!contentRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
    setScrollTop(scrollTop);
    
    const thumbH = Math.max(
      (clientHeight / scrollHeight) * clientHeight,
      20
    );
    setThumbHeight(thumbH);
  };

  const handleTrackClick = (e) => {
    if (!contentRef.current || !thumbRef.current) return;
    const trackRect = e.currentTarget.getBoundingClientRect();
    const thumbOffset = e.clientY - trackRect.top - thumbHeight / 2;
    const scrollPercentage = thumbOffset / (trackRect.height - thumbHeight);
    contentRef.current.scrollTop =
      scrollPercentage * (contentRef.current.scrollHeight - contentRef.current.clientHeight);
  };

  const handleThumbMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
    
    const startY = e.clientY;
    const startScrollTop = scrollTop;
    
    const handleMouseMove = (e) => {
      if (!isDragging || !contentRef.current) return;
      const deltaY = e.clientY - startY;
      const trackHeight = contentRef.current.clientHeight - thumbHeight;
      const scrollDelta = (deltaY / trackHeight) * contentRef.current.scrollHeight;
      contentRef.current.scrollTop = startScrollTop + scrollDelta;
    };
    
    const handleMouseUp = () => {
      setIsDragging(false);
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
    
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownMenuRef.current && !dropdownMenuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (contentRef.current) {
      handleScroll();
    }
  }, [isOpen, options]);

  return (
      <div className="relative md:mr-4 mr-2" ref={dropdownMenuRef}>
      <button
        className={`relative xl:w-[205px] lg:w-[160px] md:w-[100px] w-[70px] h-[20px] md:h-[53px] bg-[#2E453D] text-white flex justify-between items-center text-[8px] md:text-[17px] px-[2px] rounded-[4px] truncate`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={`whitespace-normal break-words font-normal leading-[0.90] text-center capitalize w-full ${
          getDisplayValue() === "-" ? "text-gray-400" : ""
        }`}>
          {capitalizeWords(getDisplayValue())}
        </span>
        
        <span className="absolute bottom-[1px] right-3 text-[6px] md:text-[8px] text-white">
          {(type === "COUNTRY" && value?.code) || 
           (type === "REGION" && value?.value) || 
           (type === "DISTRICT" && value?.value) || 
           (type === "SMMEs" && value?.value) || 
           '-'}
        </span>
        
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751799445/Expand_down_light_syoynq.png"
          alt="expand"
          className="absolute bottom-2 right-2 w-2 h-2 md:w-5 md:h-5"
        />
      </button>

   
      <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.2, ease: "easeInOut" }}
                        className="bg-[#2E453D]/80 rounded-b-[5px] overflow-x-auto backdrop-blur-sm absolute top-full mt-1 left-0 w-full z-50 md:w-[205px]"
                    >
                        <div className="px-3 py-2">
                            <div className="flex items-center justify-between mb-2">
                                <h3 className="text-white text-sm font-semibold">
                                    {getHeaderTitle()}
                                </h3>
                                <img 
                                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750628487/Export_light_kuxwb6.png" 
                                    alt="Export icon"
                                    className="w-4 h-4 ml-2 cursor-pointer"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsOpen(false);
                                    }}
                                />
                            </div>
                            <div className="custom-scroll-area max-h-[200px]">
                                <div
                                    className="custom-scroll-content"
                                    ref={contentRef}
                                    onScroll={handleScroll}
                                >
                                    <ul className="space-y-2">
                                        {type === "CROPS" || type === "LIVESTOCK" || type === "FOREST"
                                            ? renderGroupedItems()
                                            : renderRegularItems()}
                                    </ul>
                                </div>
                                {/* ... scroll track code ... */}
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
    </div>
  );
};

const Dropdown3 = ({ type, value, options, onSelect, countryValue }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownMenuRef = useRef(null);
  const contentRef = useRef(null);
  const thumbRef = useRef(null);
  const [thumbHeight, setThumbHeight] = useState(20);
  const [scrollTop, setScrollTop] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});

  // Define all possible options
  const allOptions = {
     
      CROPS: [
          { id: "african-night-shade", name: "African Night Shade", value: "african-night-shade" },
          { id: "alovera", name: "Alovera", value: "alovera" },
          { id: "avocados", name: "Avocados", value: "avocados" },
          { id: "apple", name: "Apple", value: "apple" },
          { id: "bananas", name: "Bananas", value: "bananas" },
          { id: "baobab", name: "Baobab", value: "baobab" },
          { id: "beans", name: "Beans", value: "beans" },
          { id: "beetroot", name: "Beetroot", value: "beetroot" },
          { id: "black-nightshade", name: "Black Nightshade", value: "black-nightshade" },
          { id: "cabbage", name: "Cabbage", value: "cabbage" },
          { id: "capsicum", name: "Capsicum", value: "capsicum" }
      ],
      LIVESTOCK: [
          { id: "bees", name: "Bees", value: "bees" },
          { id: "cattle-dairy", name: "Cattle - Dairy", value: "cattle-dairy" },
          { id: "fish", name: "Fish", value: "fish" },
          { id: "catfish", name: "Catfish", value: "catfish" }
      ],
      FOREST: [
          { id: "bamboo", name: "Bamboo", value: "bamboo" },
          { id: "blue-gum", name: "Blue Gum", value: "blue-gum" }
      ]
  };

  // Get the correct options based on dropdown type
  const dropdownOptions = allOptions[type] || options || [];

  const capitalizeWords = (str) => {
      if (!str) return "";
      return str
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(" ");
  };

  const getDisplayValue = () => {
      if (value) {
          if (type === "COUNTRY") return value.name || "-";
          return value.name || value.value || "-";
      }
      return "-";
  };

  const getHeaderTitle = () => {
      switch (type) {
          case "COUNTRY":
              return "Countries";
          case "REGION":
              return "Regions";
          case "DISTRICT":
              return "Districts";
          case "MUNICIPALITY":
              return "Municipalities";
          case "SMMEs":
              return "SMMEs";
          case "VALUE CHAIN":
              return "Value Chains";
          case "PROJECT":
              return "Projects";
          case "USER TYPE":
              return "User Types";
          case "SERVICES":
              return "Services";
          case "CROPS":
              return "Crops";
          case "LIVESTOCK":
              return "Livestock";
          case "FOREST":
              return "Forest";
          default:
              return "Select Option";
      }
  };

  const toggleItemSelection = (itemId) => {
      setSelectedItems(prev => ({
          ...prev,
          [itemId]: !prev[itemId]
      }));
  };

  const renderRegularItems = () => {
      return dropdownOptions?.map((option, index) => (
          <li
              key={index}
              className={`group flex items-center justify-between px-3 py-2 text-sm cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                  selectedItems[option.id] ? "bg-[#2E453D]" : ""
              }`}
          >
              <span 
                  className="text-white"
                  onClick={(e) => {
                      e.stopPropagation();
                      onSelect(option);
                      setIsOpen(false);
                  }}
              >
                  {option.name || option.value}
              </span>
              <button 
                  onClick={(e) => {
                      e.stopPropagation();
                      toggleItemSelection(option.id);
                  }}
              >
                  {selectedItems[option.id] ? <SelectedIcon /> : <UnselectedIcon />}
              </button>
          </li>
      ));
  };

  const renderGroupedItems = () => {
    return (
      <div className="mb-2">
        {/* Always show all sections */}
        <h4 className="text-white font-bold px-3 py-1 bg-[#2E453D]/50">CROPS</h4>
        <ul>
          {allOptions.CROPS.map((item, index) => (
            <li
              key={`crop-${index}`}
              className={`group flex items-center justify-between px-3 py-2 text-sm text-white cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                selectedItems[item.id] ? "bg-[#2E453D]" : ""
              }`}
            >
              <span 
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect(item);
                  setIsOpen(false);
                }}
              >
                {item.name}
              </span>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  toggleItemSelection(item.id);
                }}
              >
                {selectedItems[item.id] ? <SelectedIcon /> : <UnselectedIcon />}
              </button>
            </li>
          ))}
        </ul>
  
        <h4 className="text-white font-bold px-3 py-1 bg-[#2E453D]/50 mt-2">LIVESTOCK</h4>
        <ul>
          {allOptions.LIVESTOCK.map((item, index) => (
            <li
              key={`livestock-${index}`}
              className={`group flex items-center justify-between px-3 py-2 text-sm text-white cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                selectedItems[item.id] ? "bg-[#2E453D]" : ""
              }`}
            >
              <span 
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect(item);
                  setIsOpen(false);
                }}
              >
                {item.name}
              </span>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  toggleItemSelection(item.id);
                }}
              >
                {selectedItems[item.id] ? <SelectedIcon /> : <UnselectedIcon />}
              </button>
            </li>
          ))}
        </ul>
  
        <h4 className="text-white font-bold px-3 py-1 bg-[#2E453D]/50 mt-2">FOREST</h4>
        <ul>
          {allOptions.FOREST.map((item, index) => (
            <li
              key={`forest-${index}`}
              className={`group flex items-center justify-between px-3 py-2 text-sm text-white cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                selectedItems[item.id] ? "bg-[#2E453D]" : ""
              }`}
            >
              <span 
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect(item);
                  setIsOpen(false);
                }}
              >
                {item.name}
              </span>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  toggleItemSelection(item.id);
                }}
              >
                {selectedItems[item.id] ? <SelectedIcon /> : <UnselectedIcon />}
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const UnselectedIcon = () => (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8.5" cy="8.5" r="8" fill="#D9D9D9" stroke="none"/>
    </svg>
  );
  
  const SelectedIcon = () => (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8.5" cy="8.5" r="8" fill="#2E453D" stroke="#FFBD26"/>
      <path d="M5 8.5L7.5 11L12 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  const handleScroll = () => {
    if (!contentRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
    setScrollTop(scrollTop);
    
    const thumbH = Math.max(
      (clientHeight / scrollHeight) * clientHeight,
      20
    );
    setThumbHeight(thumbH);
  };

  const handleTrackClick = (e) => {
    if (!contentRef.current || !thumbRef.current) return;
    const trackRect = e.currentTarget.getBoundingClientRect();
    const thumbOffset = e.clientY - trackRect.top - thumbHeight / 2;
    const scrollPercentage = thumbOffset / (trackRect.height - thumbHeight);
    contentRef.current.scrollTop =
      scrollPercentage * (contentRef.current.scrollHeight - contentRef.current.clientHeight);
  };

  const handleThumbMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
    
    const startY = e.clientY;
    const startScrollTop = scrollTop;
    
    const handleMouseMove = (e) => {
      if (!isDragging || !contentRef.current) return;
      const deltaY = e.clientY - startY;
      const trackHeight = contentRef.current.clientHeight - thumbHeight;
      const scrollDelta = (deltaY / trackHeight) * contentRef.current.scrollHeight;
      contentRef.current.scrollTop = startScrollTop + scrollDelta;
    };
    
    const handleMouseUp = () => {
      setIsDragging(false);
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
    
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownMenuRef.current && !dropdownMenuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (contentRef.current) {
      handleScroll();
    }
  }, [isOpen, options]);

  return (
      <div className="relative md:mr-4 mr-2" ref={dropdownMenuRef}>
      <button
        className={`relative xl:w-[205px] lg:w-[160px] md:w-[100px] w-[70px] h-[20px] md:h-[53px] bg-[#2E453D] text-white flex justify-between items-center text-[8px] md:text-[17px] px-[2px] rounded-[4px] truncate`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={`whitespace-normal break-words font-normal leading-[0.90] text-center capitalize w-full ${
          getDisplayValue() === "-" ? "text-gray-400" : ""
        }`}>
          {capitalizeWords(getDisplayValue())}
        </span>
        
        <span className="absolute bottom-[1px] right-3 text-[6px] md:text-[8px] text-white">
          {(type === "COUNTRY" && value?.code) || 
           (type === "REGION" && value?.value) || 
           (type === "DISTRICT" && value?.value) || 
           (type === "SMMEs" && value?.value) || 
           '-'}
        </span>
        
        <div
                      className="w-[15px] h-[15px] md:h-[50px] md:w-[40px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
                      onClick={() => setIsOpen(prev => !prev)}
                  >
                      <img
                          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
                          alt="expand"
                          className="w-2 h-[10px] md:w-6 md:h-[24px]"
                      />
                  </div>
      </button>

   
      <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.2, ease: "easeInOut" }}
                        className="bg-[#2E453D]/80 rounded-b-[5px] overflow-x-auto backdrop-blur-sm absolute top-full mt-1 left-0 w-full z-50 md:w-[205px]"
                    >
                        <div className="px-3 py-2">
                            <div className="flex items-center justify-between mb-2">
                                <h3 className="text-white text-sm font-semibold">
                                    {getHeaderTitle()}
                                </h3>
                                <img 
                                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750628487/Export_light_kuxwb6.png" 
                                    alt="Export icon"
                                    className="w-4 h-4 ml-2 cursor-pointer"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsOpen(false);
                                    }}
                                />
                            </div>
                            <div className="custom-scroll-area max-h-[200px]">
                                <div
                                    className="custom-scroll-content"
                                    ref={contentRef}
                                    onScroll={handleScroll}
                                >
                                    <ul className="space-y-2">
                                        {type === "CROPS" || type === "LIVESTOCK" || type === "FOREST"
                                            ? renderGroupedItems()
                                            : renderRegularItems()}
                                    </ul>
                                </div>
                                {/* ... scroll track code ... */}
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
    </div>
  );
};
  const Dropdown1 = ({ type, value, options, onSelect, countryValue }) => {
      const [isOpen, setIsOpen] = useState(false);
      const dropdownMenuRef = useRef(null);
      const contentRef = useRef(null);
      const thumbRef = useRef(null);
      const [thumbHeight, setThumbHeight] = useState(20);
      const [scrollTop, setScrollTop] = useState(0);
      const [isDragging, setIsDragging] = useState(false);
      const [selectedItems, setSelectedItems] = useState({});
    
      // Add your specific options based on the type
      const dropdownOptions = type === "SERVICES" ? [
        { id: "contracts", name: "Contracts", value: "contracts" },
        { id: "calendar", name: "Calendar", value: "calendar" },
        { id: "verification", name: "Verification", value: "verification" },
        { id: "crop-advisory", name: "Crop Advisory", value: "crop-advisory" },
        { id: "livestock-advisory", name: "Livestock Advisory", value: "livestock-advisory" },
        { id: "pest-alert", name: "Pest Alert", value: "pest-alert" },
        { id: "disease-alert", name: "Disease Alert", value: "disease-alert" },
        { id: "credit-score", name: "Credit Score", value: "credit-score" },
        { id: "weather", name: "Weather", value: "weather" }
      ] : options || [];
    
      const capitalizeWords = (str) => {
        if (!str) return "";
        return str
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(" ");
      };
    
      const getDisplayValue = () => {
        if (value) {
          if (type === "COUNTRY") return value.name || "-";
          return value.name || value.value || "-";
        }
        return "-";
      };
    
      const getHeaderTitle = () => {
        switch (type) {
          case "COUNTRY":
            return "Countries";
          case "REGION":
            return "Regions";
          case "DISTRICT":
            return "Districts";
          case "MUNICIPALITY":
            return "Municipalities";
          case "SMMEs":
            return "SMMEs";
          case "VALUE CHAIN":
            return "Value Chains";
          case "PROJECT":
            return "Projects";
          case "USER TYPE":
            return "User Types";
          case "SERVICES":
            return "Services";
          default:
            return "Select Option";
        }
      };
    
      const toggleItemSelection = (itemId) => {
        setSelectedItems(prev => ({
          ...prev,
          [itemId]: !prev[itemId]
        }));
      };
    
      const renderRegularItems = () => {
        return dropdownOptions?.map((option, index) => (
          <li
            key={index}
            className={`group flex items-center justify-between px-3 py-2 text-sm cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
              selectedItems[option.id] ? "bg-[#2E453D]" : ""
            }`}
          >
            <span 
              className="text-white"
              onClick={(e) => {
                e.stopPropagation();
                onSelect(option);
                setIsOpen(false);
              }}
            >
              {option.name || option.value}
            </span>
            <button 
              onClick={(e) => {
                e.stopPropagation();
                toggleItemSelection(option.id);
              }}
            >
              {selectedItems[option.id] ? <SelectedIcon /> : <UnselectedIcon />}
            </button>
          </li>
        ));
      };
    
      const renderGroupedItems = () => {
        return renderRegularItems();
      };
    
      const UnselectedIcon = () => (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="8.5" cy="8.5" r="8" fill="#D9D9D9" stroke="none"/>
        </svg>
      );
      
      const SelectedIcon = () => (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="8.5" cy="8.5" r="8" fill="#2E453D" stroke="#FFBD26"/>
          <path d="M5 8.5L7.5 11L12 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    
      const handleScroll = () => {
        if (!contentRef.current) return;
        const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
        setScrollTop(scrollTop);
        
        const thumbH = Math.max(
          (clientHeight / scrollHeight) * clientHeight,
          20
        );
        setThumbHeight(thumbH);
      };
    
      const handleTrackClick = (e) => {
        if (!contentRef.current || !thumbRef.current) return;
        const trackRect = e.currentTarget.getBoundingClientRect();
        const thumbOffset = e.clientY - trackRect.top - thumbHeight / 2;
        const scrollPercentage = thumbOffset / (trackRect.height - thumbHeight);
        contentRef.current.scrollTop =
          scrollPercentage * (contentRef.current.scrollHeight - contentRef.current.clientHeight);
      };
    
      const handleThumbMouseDown = (e) => {
        e.preventDefault();
        setIsDragging(true);
        
        const startY = e.clientY;
        const startScrollTop = scrollTop;
        
        const handleMouseMove = (e) => {
          if (!isDragging || !contentRef.current) return;
          const deltaY = e.clientY - startY;
          const trackHeight = contentRef.current.clientHeight - thumbHeight;
          const scrollDelta = (deltaY / trackHeight) * contentRef.current.scrollHeight;
          contentRef.current.scrollTop = startScrollTop + scrollDelta;
        };
        
        const handleMouseUp = () => {
          setIsDragging(false);
          document.removeEventListener("mousemove", handleMouseMove);
          document.removeEventListener("mouseup", handleMouseUp);
        };
        
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
      };
    
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (dropdownMenuRef.current && !dropdownMenuRef.current.contains(event.target)) {
            setIsOpen(false);
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, []);
    
      useEffect(() => {
        if (contentRef.current) {
          handleScroll();
        }
      }, [isOpen, options]);
    
      return (
          <div className="relative md:mr-4 mr-2" ref={dropdownMenuRef}>
          <button
            className={`relative xl:w-[600px] lg:w-[160px] md:w-[100px] w-[70px] h-[20px] md:h-[53px] bg-[#2E453D] text-white flex justify-between items-center text-[8px] md:text-[17px] px-[2px] rounded-[4px] truncate`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className={`whitespace-normal break-words font-normal leading-[0.90] text-center capitalize w-full ${
              getDisplayValue() === "-" ? "text-gray-400" : ""
            }`}>
              {capitalizeWords(getDisplayValue())}
            </span>
            
            <span className="absolute bottom-[1px] right-3 text-[6px] md:text-[8px] text-white">
              {(type === "COUNTRY" && value?.code) || 
               (type === "REGION" && value?.value) || 
               (type === "DISTRICT" && value?.value) || 
               (type === "SMMEs" && value?.value) || 
               '-'}
            </span>
            
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751799445/Expand_down_light_syoynq.png"
              alt="expand"
              className="absolute bottom-2 right-2 w-2 h-2 md:w-5 md:h-5"
            />
          </button>
    
          <AnimatePresence>
            {isOpen && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.2, ease: "easeInOut" }}
                className="bg-[#2E453D]/80 rounded-b-[5px] overflow-hidden backdrop-blur-sm absolute top-full mt-1 left-0 w-full z-50 md:w-[600px]"
              >
                <div className="px-3 py-2">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-white text-sm font-semibold">
                      {getHeaderTitle()}
                    </h3>
                    <img 
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750628487/Export_light_kuxwb6.png" 
                      alt="Export icon"
                      className="w-4 h-4 ml-2 cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsOpen(false);
                      }}
                    />
                  </div>
                  <div className="custom-scroll-area max-h-[200px]">
                    <div
                      className="custom-scroll-content"
                      ref={contentRef}
                      onScroll={handleScroll}
                    >
                      <ul className="space-y-2">
                        {type === "SMMEs" || type === "TYPE OF FARMING" 
                          ? renderGroupedItems()
                          : renderRegularItems()}
                      </ul>
                    </div>
                    <div className="custom-scroll-track" onClick={handleTrackClick}>
                      <div
                        ref={thumbRef}
                        className="custom-scroll-thumb"
                        style={{
                          height: `${thumbHeight}px`,
                          top: `${scrollTop}px`,
                          cursor: isDragging ? "grabbing" : "grab",
                        }}
                        onMouseDown={handleThumbMouseDown}
                      ></div>
                    </div>
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      );
    };
    const Dropdown4 = ({ type, value, options, onSelect, countryValue }) => {
      const [isOpen, setIsOpen] = useState(false);
      const dropdownMenuRef = useRef(null);
      const contentRef = useRef(null);
      const thumbRef = useRef(null);
      const [thumbHeight, setThumbHeight] = useState(20);
      const [scrollTop, setScrollTop] = useState(0);
      const [isDragging, setIsDragging] = useState(false);
      const [selectedItems, setSelectedItems] = useState({});
    
      // Add your specific options based on the type
      const dropdownOptions = type === "SERVICES" ? [
        { id: "contracts", name: "Contracts", value: "contracts" },
        { id: "calendar", name: "Calendar", value: "calendar" },
        { id: "verification", name: "Verification", value: "verification" },
        { id: "crop-advisory", name: "Crop Advisory", value: "crop-advisory" },
        { id: "livestock-advisory", name: "Livestock Advisory", value: "livestock-advisory" },
        { id: "pest-alert", name: "Pest Alert", value: "pest-alert" },
        { id: "disease-alert", name: "Disease Alert", value: "disease-alert" },
        { id: "credit-score", name: "Credit Score", value: "credit-score" },
        { id: "weather", name: "Weather", value: "weather" }
      ] : options || [];
    
      const capitalizeWords = (str) => {
        if (!str) return "";
        return str
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(" ");
      };
    
      const getDisplayValue = () => {
        if (value) {
          if (type === "COUNTRY") return value.name || "-";
          return value.name || value.value || "-";
        }
        return "-";
      };
    
      const getHeaderTitle = () => {
        switch (type) {
          case "COUNTRY":
            return "Countries";
          case "REGION":
            return "Regions";
          case "DISTRICT":
            return "Districts";
          case "MUNICIPALITY":
            return "Municipalities";
          case "SMMEs":
            return "SMMEs";
          case "VALUE CHAIN":
            return "Value Chains";
          case "PROJECT":
            return "Projects";
          case "USER TYPE":
            return "User Types";
          case "SERVICES":
            return "Services";
          default:
            return "Select Option";
        }
      };
    
      const toggleItemSelection = (itemId) => {
        setSelectedItems(prev => ({
          ...prev,
          [itemId]: !prev[itemId]
        }));
      };
    
      const renderRegularItems = () => {
        return dropdownOptions?.map((option, index) => (
          <li
            key={index}
            className={`group flex items-center justify-between px-3 py-2 text-sm cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
              selectedItems[option.id] ? "bg-[#2E453D]" : ""
            }`}
          >
            <span 
              className="text-white"
              onClick={(e) => {
                e.stopPropagation();
                onSelect(option);
                setIsOpen(false);
              }}
            >
              {option.name || option.value}
            </span>
            <button 
              onClick={(e) => {
                e.stopPropagation();
                toggleItemSelection(option.id);
              }}
            >
              {selectedItems[option.id] ? <SelectedIcon /> : <UnselectedIcon />}
            </button>
          </li>
        ));
      };
    
      const renderGroupedItems = () => {
        return renderRegularItems();
      };
    
      const UnselectedIcon = () => (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="8.5" cy="8.5" r="8" fill="#D9D9D9" stroke="none"/>
        </svg>
      );
      
      const SelectedIcon = () => (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="8.5" cy="8.5" r="8" fill="#2E453D" stroke="#FFBD26"/>
          <path d="M5 8.5L7.5 11L12 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    
      const handleScroll = () => {
        if (!contentRef.current) return;
        const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
        setScrollTop(scrollTop);
        
        const thumbH = Math.max(
          (clientHeight / scrollHeight) * clientHeight,
          20
        );
        setThumbHeight(thumbH);
      };
    
      const handleTrackClick = (e) => {
        if (!contentRef.current || !thumbRef.current) return;
        const trackRect = e.currentTarget.getBoundingClientRect();
        const thumbOffset = e.clientY - trackRect.top - thumbHeight / 2;
        const scrollPercentage = thumbOffset / (trackRect.height - thumbHeight);
        contentRef.current.scrollTop =
          scrollPercentage * (contentRef.current.scrollHeight - contentRef.current.clientHeight);
      };
    
      const handleThumbMouseDown = (e) => {
        e.preventDefault();
        setIsDragging(true);
        
        const startY = e.clientY;
        const startScrollTop = scrollTop;
        
        const handleMouseMove = (e) => {
          if (!isDragging || !contentRef.current) return;
          const deltaY = e.clientY - startY;
          const trackHeight = contentRef.current.clientHeight - thumbHeight;
          const scrollDelta = (deltaY / trackHeight) * contentRef.current.scrollHeight;
          contentRef.current.scrollTop = startScrollTop + scrollDelta;
        };
        
        const handleMouseUp = () => {
          setIsDragging(false);
          document.removeEventListener("mousemove", handleMouseMove);
          document.removeEventListener("mouseup", handleMouseUp);
        };
        
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
      };
    
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (dropdownMenuRef.current && !dropdownMenuRef.current.contains(event.target)) {
            setIsOpen(false);
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, []);
    
      useEffect(() => {
        if (contentRef.current) {
          handleScroll();
        }
      }, [isOpen, options]);
    
      return (
          <div className="relative md:mr-4 mr-2" ref={dropdownMenuRef}>
          <button
            className={`relative xl:w-[200px] lg:w-[160px] md:w-[100px] w-[70px] h-[20px] md:h-[53px] bg-[#2E453D] text-white flex justify-between items-center text-[8px] md:text-[17px] px-[2px] rounded-[4px] truncate`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className={`whitespace-normal break-words font-normal leading-[0.90] text-center capitalize w-full ${
              getDisplayValue() === "-" ? "text-gray-400" : ""
            }`}>
              {capitalizeWords(getDisplayValue())}
            </span>
            
            <span className="absolute bottom-[1px] right-3 text-[6px] md:text-[8px] text-white">
              {(type === "COUNTRY" && value?.code) || 
               (type === "REGION" && value?.value) || 
               (type === "DISTRICT" && value?.value) || 
               (type === "SMMEs" && value?.value) || 
               '-'}
            </span>
            
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751799445/Expand_down_light_syoynq.png"
              alt="expand"
              className="absolute bottom-2 right-2 w-2 h-2 md:w-5 md:h-5"
            />
          </button>
    
          <AnimatePresence>
            {isOpen && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.2, ease: "easeInOut" }}
                className="bg-[#2E453D]/80 rounded-b-[5px] overflow-hidden backdrop-blur-sm absolute top-full mt-1 left-0 w-full z-50 md:w-[600px]"
              >
                <div className="px-3 py-2">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-white text-sm font-semibold">
                      {getHeaderTitle()}
                    </h3>
                    <img 
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750628487/Export_light_kuxwb6.png" 
                      alt="Export icon"
                      className="w-4 h-4 ml-2 cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsOpen(false);
                      }}
                    />
                  </div>
                  <div className="custom-scroll-area max-h-[200px]">
                    <div
                      className="custom-scroll-content"
                      ref={contentRef}
                      onScroll={handleScroll}
                    >
                      <ul className="space-y-2">
                        {type === "SMMEs" || type === "TYPE OF FARMING" 
                          ? renderGroupedItems()
                          : renderRegularItems()}
                      </ul>
                    </div>
                    <div className="custom-scroll-track" onClick={handleTrackClick}>
                      <div
                        ref={thumbRef}
                        className="custom-scroll-thumb"
                        style={{
                          height: `${thumbHeight}px`,
                          top: `${scrollTop}px`,
                          cursor: isDragging ? "grabbing" : "grab",
                        }}
                        onMouseDown={handleThumbMouseDown}
                      ></div>
                    </div>
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      );
    };
    const Dropdown2 = ({ label, items, type, isProjectDropdown, onChange }) => {
      const [isOpen, setIsOpen] = useState(false);
      const [selectedItems, setSelectedItems] = useState([]);
      const [selectedCircles, setSelectedCircles] = useState({});
      
      const contentRef = useRef(null);
      const [scrollTop, setScrollTop] = useState(0);
      const [thumbHeight, setThumbHeight] = useState(40);
      const [isDragging, setIsDragging] = useState(false);
      const [startY, setStartY] = useState(0);
      const [startScrollTop, setStartScrollTop] = useState(0);
      const thumbRef = useRef(null);
    
      const toggleCircle = (item) => {
          setSelectedCircles((prev) => ({
              ...prev,
              [item]: !prev[item],
          }));
      };
    
      const handleSelect = (item) => {
          setSelectedItems(prev => {
              if (prev.includes(item)) {
                  return prev.filter(i => i !== item);
              } else {
                  return [...prev, item];
              }
          });
          
          if (typeof onChange === "function") {
              onChange(type, item);
          }
      };
    
      useEffect(() => {
          const content = contentRef.current;
          if (!content) return;
    
          const updateThumbHeight = () => {
              const { scrollHeight, clientHeight } = content;
              const visibleRatio = clientHeight / scrollHeight;
              setThumbHeight(Math.max(visibleRatio * clientHeight, 20));
          };
    
          updateThumbHeight();
          window.addEventListener("resize", updateThumbHeight);
          return () => window.removeEventListener("resize", updateThumbHeight);
      }, [isOpen, items]);
    
      const handleScroll = () => {
          const content = contentRef.current;
          if (!content) return;
    
          const { scrollTop, scrollHeight, clientHeight } = content;
          const maxScrollTop = scrollHeight - clientHeight;
          const scrollRatio = scrollTop / maxScrollTop;
          const trackHeight = content.clientHeight - thumbHeight;
          setScrollTop(scrollRatio * trackHeight);
      };
    
      const handleThumbMouseDown = (e) => {
          e.preventDefault();
          e.stopPropagation();
    
          setIsDragging(true);
          setStartY(e.clientY);
          setStartScrollTop(contentRef.current.scrollTop);
    
          document.addEventListener("mousemove", handleThumbMouseMove);
          document.addEventListener("mouseup", handleThumbMouseUp);
          document.body.style.cursor = "grabbing";
      };
    
      const handleThumbMouseMove = (e) => {
          if (!isDragging) return;
    
          const deltaY = e.clientY - startY;
          const content = contentRef.current;
          const { scrollHeight, clientHeight } = content;
          const maxScrollTop = scrollHeight - clientHeight;
          const trackHeight = clientHeight - thumbHeight;
    
          const scrollDelta = (deltaY / trackHeight) * maxScrollTop;
          const newScrollTop = Math.min(
              Math.max(0, startScrollTop + scrollDelta),
              maxScrollTop
          );
    
          content.scrollTop = newScrollTop;
      };
    
      const handleThumbMouseUp = () => {
          setIsDragging(false);
          document.removeEventListener("mousemove", handleThumbMouseMove);
          document.removeEventListener("mouseup", handleThumbMouseUp);
          document.body.style.cursor = "";
      };
    
      const handleTrackClick = (e) => {
          const content = contentRef.current;
          if (!content || e.target === thumbRef.current) return;
    
          const track = e.currentTarget;
          const trackRect = track.getBoundingClientRect();
          const clickPosition = e.clientY - trackRect.top;
          const thumbCenter = thumbHeight / 2;
          const scrollRatio =
              (clickPosition - thumbCenter) / (trackRect.height - thumbHeight);
    
          const { scrollHeight, clientHeight } = content;
          const maxScrollTop = scrollHeight - clientHeight;
          content.scrollTop = scrollRatio * maxScrollTop;
      };
    
      const handleButtonScroll = (direction) => {
          if (contentRef.current) {
              contentRef.current.scrollBy({
                  top: direction === 'up' ? -50 : 50,
                  behavior: 'smooth'
              });
          }
      };
    
      return (
          <div className="flex flex-col w-full relative">
              <span className="text-[6px] md:text-[20px] md:mb-3 font-extrabold">
                  {isProjectDropdown ? "" : label || "LANGUAGE"}
              </span>
              <div className="flex relative z-20 w-fit">
                  <button
                      onClick={() => {
                          if (isProjectDropdown && selectedItems.includes("Funding")) {
                              window.location.href = "/funding";
                          } else {
                              setIsOpen(prev => !prev);
                          }
                      }}
                      className={`xl:w-[160px] lg:w-[140px] md:w-[55px] w-[50px] h-[15px] md:h-[50px] bg-[#2E453D] text-white font-medium flex items-center px-1 rounded-l-[5px]`}
                  >
                      <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] truncate">
                          {selectedItems.length > 0 ? selectedItems[0] : "-"}
                      </span>
                  </button>
    
                  <div
                      className="w-[15px] h-[15px] md:h-[50px] md:w-[40px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
                      onClick={() => setIsOpen(prev => !prev)}
                  >
                      <img
                          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
                          alt="expand"
                          className="w-2 h-[10px] md:w-6 md:h-[24px]"
                      />
                  </div>
              </div>
    
              <AnimatePresence>
                  {isOpen && (
                      <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -10 }}
                          className="absolute top-full mt-1 left-0 z-[100] md:w-[220px] w-[70px] border-[1px] border-[#979797]/80 bg-white rounded-[1px] shadow-lg p-2"
                      >
                          <div className="w-full flex justify-end py-1">
                              <button 
                                  onClick={(e) => {
                                      e.stopPropagation();
                                      handleButtonScroll('up');
                                  }}
                                  className="p-1"
                              >
                                  <img 
                                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461105/Expand_up_mflvtu.png" 
                                      alt="Scroll up" 
                                      className="w-3 h-3"
                                  />
                              </button>
                          </div>
    
                          <div className="custom-scroll-area">
                              <ul
                                  className="custom-scroll-content"
                                  ref={contentRef}
                                  onScroll={handleScroll}
                              >
                              <li className="flex items-center justify-between px-2 py-1 mb-2">
                                  <span className="text-[6px] md:text-[20px] font-semibold">
                                      {isProjectDropdown ? "Purpose" : label || "Language"}
                                  </span>
                                  <img
                                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750034880/Export_1_vurzim.png"
                                      alt="icon"
                                      className="md:w-[30px] md:h-[30px] h-[7px] w-[7px] cursor-pointer"
                                      onClick={(e) => {
                                          e.stopPropagation();
                                          setIsOpen(false);
                                      }}
                                  />
                              </li>
                                  
                                  {items && items.map((item, index) => (
                                      <li
                                          key={index}
                                          className={`flex items-center justify-between md:px-3 px-1 md:py-2 py-1 md:mt-1 rounded-md hover:bg-gray-100 cursor-pointer ${
                                              selectedItems.includes(item) ? "bg-[#E7EBEB]" : ""
                                          }`}
                                          onClick={() => handleSelect(item)}
                                      >
                                          <span className="text-black text-[4px] md:text-[18px]">
                                              {item}
                                          </span>
                                          <div
                                              className={`w-2 h-2 md:w-8 md:h-8 rounded-full ${
                                                  selectedItems.includes(item) ? "bg-[#152C24]" : "bg-gray-200"
                                              }`}
                                          ></div>
                                      </li>
                                  ))}
                              </ul>
                              <div className="custom-scroll-track" onClick={handleTrackClick}>
                                  <div
                                      ref={thumbRef}
                                      className="custom-scroll-thumb"
                                      style={{
                                          height: `${thumbHeight}px`,
                                          top: `${scrollTop}px`,
                                          cursor: isDragging ? "grabbing" : "grab",
                                      }}
                                      onMouseDown={handleThumbMouseDown}
                                  ></div>
                              </div>
                          </div>
    
                          <div className="w-full flex justify-end py-1">
                              <button 
                                  onClick={(e) => {
                                      e.stopPropagation();
                                      handleButtonScroll('down');
                                  }}
                                  className="p-1"
                              >
                                  <img 
                                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461085/Expand_down_vbf4bb.png" 
                                      alt="Scroll down" 
                                      className="w-3 h-3"
                                  />
                              </button>
                          </div>
                      </motion.div>
                  )}
              </AnimatePresence>
              <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
                  {isProjectDropdown
                      ? "Select type of Produce"
                      : `Select  ${type === "FACILITATOR" ? "Weekly report" : label}`}
              </p>
    
              <style jsx>{`
                  .custom-scroll-area {
                      position: relative;
                      max-height: 200px;
                      display: flex;
                      overflow: hidden;
                  }
    
                  .custom-scroll-content {
                      flex: 1;
                      overflow-y: scroll;
                      scrollbar-width: none;
                      -ms-overflow-style: none;
                      padding-right: 4px;
                  }
    
                  .custom-scroll-content::-webkit-scrollbar {
                      display: none;
                  }
    
                  .custom-scroll-track {
                      width: 14px;
                      background: #e7ebeb;
                      border-radius: 3px;
                      position: relative;
                      margin-left: 4px;
                      cursor: pointer;
                  }
    
                  .custom-scroll-thumb {
                      width: 100%;
                      background: #979797;
                      border-radius: 3px;
                      position: absolute;
                      right: 0;
                      transition: background 0.2s;
                  }
    
                  .custom-scroll-thumb:hover {
                      background: #444;
                  }
    
                  @media (max-width: 768px) {
                      .custom-scroll-track {
                          width: 4px;
                          margin-left: 2px;
                      }
                      .custom-scroll-area {
                          position: relative;
                          max-height: 150px;
                          display: flex;
                          overflow: hidden;
                          width: 100%;
                      }
                  }
              `}</style>
          </div>
      );
    };
    const getRegionMap = (country) => {
      const countryMappings = {
        'South Africa': {
          "Gauteng": "01",
          "Eastern Cape": "02",
          "Limpopo": "03",
          "KwaZulu-Natal": "04",
          "Mpumalanga": "05",
          "Western Cape": "06",
          "North West": "07",
          "Northern Cape": "08",
          "Free State": "09"
        },
        'Botswana': {
          "Central": "27",
          "Chobe": "67",
          "Ghanzi": "65",
          "Kgalagadi": "69",
          "Kgatleng": "31",
          "Kweneng": "31",
          "North-East": "26",
          "North-West (Ngamiland)": "66",
          "South-East": "24",
          "Southern": "62"
        },
        'Kenya': {
          "Mombasa": "1",
          "Kwale": "2",
          "Kilifi": "3",
          "Tana River": "4",
          "Lamu": "5",
          "Taita Taveta": "6",
          "Garissa": "7",
          "Wajir": "8",
          "Mandera": "9",
          "Marsabit": "10",
          "Isiolo": "11",
          "Meru": "12",
          "Tharaka-Nithi": "13",
          "Embu": "14",
          "Kitui": "15",
          "Machakos": "16",
          "Makueni": "17",
          "Nyandarua": "18",
          "Nyeri": "19",
          "Kirinyaga": "20",
          "Murang'a": "21",
          "Kiambu": "22",
          "Turkana": "23",
          "West Pokot": "24",
          "Samburu": "25",
          "Trans Nzoia": "26",
          "Uasin Gishu": "27",
          "Elgeyo-Marakwet": "28",
          "Nandi": "29",
          "Baringo": "30",
          "Laikipia": "31",
          "Nakuru": "32",
          "Narok": "33",
          "Kajiado": "34",
          "Kericho": "35",
          "Bomet": "36",
          "Kakamega": "37",
          "Vihiga": "38",
          "Bungoma": "39",
          "Busia": "40",
          "Siaya": "41",
          "Kisumu": "42",
          "Homa Bay": "43",
          "Migori": "44",
          "Kisii": "45",
          "Nyamira": "46",
          "Nairobi City": "47"
        },
        'Namibia': {
          "Erongo": "08",
          "Hardap": "12",
          "Kavango East": "06",
          "Kavango West": "14",
          "Khomas": "11",
          "Kunene": "01",
          "Ohangwena": "04",
          "Omaheke": "10",
          "Omusati": "02",
          "Oshana": "03",
          "Oshikoto": "05",
          "Otjozondjupa": "09",
          "Zambezi": "07",
          "Karas": "013"
        },
        'Zambia': {
          "Western": "1",
          "Central": "2",
          "Eastern": "3",
          "Luapula": "4",
          "Northern": "5",
          "North-Western": "6",
          "Southern": "7",
          "Copperbelt": "8",
          "Lusaka": "9",
          "Muchinga": "10"
        },
        'Burundi': {
          "Buhumuza": "01",
          "Bujumbura": "02",
          "Burunga": "03",
          "Butanyerera": "04",
          "Gitega": "05"
        },
        'Rwanda': {
          "City of Kigali": "01",
          "Eastern": "02",
          "Northern": "03",
          "Southern": "04",
          "Western": "05"
        },
        'Uganda': {
          "Northern": "01",
          "Eastern": "02",
          "Central": "03",
          "Western": "04"
        },
        'Malawi': {
          "Northern": "01",
          "Central": "02",
          "Southern": "03"
        },
        'Angola': {
          "Bengo": "01",
          "Benguela": "02",
          "Bié": "03",
          "Cabinda": "04",
          "Cuando Cubango": "05",
          "Cuanza Norte": "07",
          "Cuanza Sul": "08",
          "Cunene": "09",
          "Huambo": "10",
          "Huíla": "11",
          "Luanda": "13",
          "Lunda Norte": "14",
          "Lunda Sul": "15",
          "Malanje": "16",
          "Moxico": "17",
          "Namibe": "19",
          "Uíge": "20",
          "Zaire": "21"
        },
        'Burkina Faso': {
          "Boucle du Mouhoun": "01",
          "Cascades": "02",
          "Centre": "03",
          "Centre-Est": "04",
          "Centre-Nord": "05",
          "Centre-Ouest": "06",
          "Centre-Sud": "07",
          "Est": "08",
          "Hauts-Bassins": "09",
          "Nord": "10",
          "Plateau-Central": "11",
          "Sahel": "12",
          "Sud-Ouest": "13"
        },
        'Eswatini': {
          "Hhohho": "01",
          "Manzini": "02",
          "Lubombo": "03",
          "Shiselweni": "04"
        },
        'Lesotho': {
          "Berea": "01",
          "Butha-Buthe": "02",
          "Leribe": "03",
          "Mafeteng": "04",
          "Maseru": "05",
          "Mohale's Hoek": "06",
          "Mokhotlong": "07",
          "Qacha's Nek": "08",
          "Quthing": "09",
          "Thaba-Tseka": "10"
        },
        'Tanzania': {
          "Arusha": "01",
          "Dar es Salaam": "02",
          "Dodoma": "03",
          "Geita": "04",
          "Iringa": "05",
          "Kagera": "06",
          "Katavi": "07",
          "Kigoma": "08",
          "Kilimanjaro": "09",
          "Lindi": "10",
          "Manyara": "11",
          "Mara": "12",
          "Mbeya": "13",
          "Mjini Magharibi (Zanzibar Urban/West)": "14",
          "Morogoro": "15",
          "Mtwara": "16",
          "Mwanza": "17",
          "Njombe": "18",
          "Pemba North": "19",
          "Pemba South": "20",
          "Pwani (Coast)": "21",
          "Rukwa": "22",
          "Ruvuma": "23",
          "Shinyanga": "24",
          "Simiyu": "25",
          "Singida": "26",
          "Songwe": "27",
          "Tabora": "28",
          "Tanga": "29"
        },
        'Cameroon': {
          "Adamawa": "01",
          "Centre": "02",
          "East": "03",
          "Far North": "04",
          "Littoral": "05",
          "North": "06",
          "North-West": "07",
          "West": "08",
          "South": "09",
          "South-West": "10"
        },
    'Democratic Republic of the Congo': {
      "Bas-Uele": "01",
      "Equateur": "02",
      "Haut-Katanga": "03",
      "Haut-Lomami": "04",
      "Haut-Uele": "05",
      "Ituri": "06",
      "Kasai": "07",
      "Kasai-Central": "08",
      "Kasai-Oriental": "09",
      "Kinshasa": "10",
      "Kongo-Central": "11",
      "Kwango": "12",
      "Kwilu": "13",
      "Lomami": "14",
      "Lualaba": "15",
      "Mai-Ndombe": "16",
      "Maniema": "17",
      "Mongala": "18",
      "Nord-Kivu": "19",
      "Nord-Ubangi": "20",
      "Sankuru": "21",
      "Sud-Kivu": "22",
      "Sud-Ubangi": "23",
      "Tanganyika": "24",
      "Tshopo": "25",
      "Tshuapa": "26"
    },
    'Congo (Kinshasa/DRC)': { // Add this as an alias
      "Bas-Uele": "01",
      "Equateur": "02",
      "Haut-Katanga": "03",
      "Haut-Lomami": "04",
      "Haut-Uele": "05",
      "Ituri": "06",
      "Kasai": "07",
      "Kasai-Central": "08",
      "Kasai-Oriental": "09",
      "Kinshasa": "10",
      "Kongo-Central": "11",
      "Kwango": "12",
      "Kwilu": "13",
      "Lomami": "14",
      "Lualaba": "15",
      "Mai-Ndombe": "16",
      "Maniema": "17",
      "Mongala": "18",
      "Nord-Kivu": "19",
      "Nord-Ubangi": "20",
      "Sankuru": "21",
      "Sud-Kivu": "22",
      "Sud-Ubangi": "23",
      "Tanganyika": "24",
      "Tshopo": "25",
      "Tshuapa": "26"
    },
        'Ethiopia': {
          "Addis Ababa": "01",
          "Afar": "02",
          "Amhara": "03",
          "Benishangul-Gumuz": "04",
          "Dire Dawa": "05",
          "Gambela": "06",
          "Harari": "07",
          "Oromia": "08",
          "Sidama": "09",
          "Somali": "10",
          "Southern Nations (SNNPR)": "11",
          "Tigray": "12"
        },
      'Côte d\'Ivoire (Ivory Coast)': {
          "Abidjan": "1",
          "Yamoussoukro": "2",
          "Bas-Sassandra": "3",
          "Comoé": "4",
          "Denguélé": "5",
          "Gôh-Djiboua": "6",
          "Lacs": "7",
          "Lagunes": "8",
          "Montagnes": "9",
          "Sassandra-Marahoué": "10",
          "Savanes": "11",
          "Vallée du Bandama": "12",
          "Woroba": "13",
          "Zanzan": "14"
        },
        'Ghana': {
          "WESTERN": "1",
          "CENTRAL": "2",
          "GREATER ACCRA": "3",
          "VOLTA": "4",
          "EASTERN": "5",
          "ASHANTI": "6",
          "WESTERN NORTH": "7",
          "AHAFO": "8",
          "BONO": "9",
          "BONO EAST": "10",
          "OTI": "11",
          "NORTHERN": "12",
          "SAVANNAH": "13",
          "UPPER WEST": "14",
          "NORTH EAST": "15",
          "UPPER EAST": "16"
        },
        'Mozambique': {
          "Cabo Delgado": "1",
          "Gaza": "2",
          "Inhambane": "3",
          "Manica": "4",
          "Maputo City": "5",
          "Maputo": "6",
          "Nampula": "7",
          "Niassa": "8",
          "Sofala": "9",
          "Tete": "10",
          "Zambezia": "11"
        },
        'Nigeria': {
          "North Central (NC)": "1",
          "North East (NE)": "2",
          "North West (NW)": "3",
          "South East (SE)": "4",
          "South South (SS)": "5",
          "South West (SW)": "6"
        },
        // ... other country mappings ...
        'Senegal': {
          "Dakar": "01",
          "Diourbel": "02",
          "Fatick": "03",
          "Kaffrine": "04",
          "Kaolack": "05",
          "Kedougou": "06",
          "Kolda": "07",
          "Louga": "08",
          "Matam": "09",
          "Saint-Louis": "10",
          "Sedhiou": "11",
          "Tambacounda": "12",
          "Thies": "13",
          "Ziguinchor": "14"
        },
      };
     // Handle case where country might be "Congo (Kinshasa/DRC)"
     const normalizedCountry = country === "Congo (Kinshasa/DRC)" 
     ? "Democratic Republic of the Congo" 
     : country;
    
    if (!countryMappings[normalizedCountry]) {
     return {
       "-": "No regions available"
     };
    }
    
      return {
        ...countryMappings[country],
      };
    };
    
    const EnterpriseSection = ({ regions, country, onTotalCalculated }) => {
      const [reportData, setReportData] = useState(null);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);
      const [totalRegistrations, setTotalRegistrations] = useState(0);
      const location = useLocation();
      const queryParams = new URLSearchParams(location.search);
      const selectedCountry = queryParams.get('country') || country?.name || 'South Africa';
      const [currentChunkTotal, setCurrentChunkTotal] = useState(0);
      const [reportSelections, setReportSelections] = useState({
        COUNTRY: "-",
        REGION: "-",
        DISTRICT: "-",
        MUNICIPALITY: "-",
        SMMEs: "-",
        "VALUE CHAIN": "-",
        PROJECT: "-",
        "USER TYPE": "-"
      });
      const [filteredTotal, setFilteredTotal] = useState(0);
    
      const updateStats = async (country, region, smmeType, landSize) => {
        const statsRef = doc(db, "stats", "registrations");
        
        try {
          await runTransaction(db, async (transaction) => {
            const statsDoc = await transaction.get(statsRef);
            let statsData = statsDoc.exists() ? statsDoc.data() : {};
            
            const countryKey = country === 'South Africa' ? 'South Africa' : country;
            
            if (!statsData[countryKey]) {
              statsData[countryKey] = {};
            }
            
            const regionKey = country === 'South Africa' 
              ? getRegionName(region, 'South Africa')
              : region;
            
            if (!statsData[countryKey][regionKey]) {
              statsData[countryKey][regionKey] = {
                total: 0,
                landSizeTotal: 0,
                bySmmetype: {}
              };
            }
            
            if (!statsData[countryKey][regionKey].bySmmetype[smmeType]) {
              statsData[countryKey][regionKey].bySmmetype[smmeType] = {
                count: 0,
                landSizeTotal: 0
              };
            }
            
            statsData[countryKey][regionKey].total = 
              (statsData[countryKey][regionKey].total || 0) + 1;
            statsData[countryKey][regionKey].landSizeTotal = 
              (statsData[countryKey][regionKey].landSizeTotal || 0) + landSize;
            statsData[countryKey][regionKey].bySmmetype[smmeType].count = 
              (statsData[countryKey][regionKey].bySmmetype[smmeType].count || 0) + 1;
            statsData[countryKey][regionKey].bySmmetype[smmeType].landSizeTotal = 
              (statsData[countryKey][regionKey].bySmmetype[smmeType].landSizeTotal || 0) + landSize;
            
            transaction.set(statsRef, statsData);
          });
        } catch (error) {
          console.error("Transaction failed:", error);
        }
      };
    
      useEffect(() => {
        const unsubscribe = onSnapshot(doc(db, "registrations", "current_selection"), (doc) => {
          if (doc.exists()) {
            const selection = doc.data();
            const region = getRegionName(selection.REGION, selection.COUNTRY || country);
            const smmeType = selection.SMMEs?.value || selection.SMMEs;
            const landSize = (selection.landData?.type1?.size || 0) + (selection.landData?.type2?.size || 0);
            
            if (region && smmeType) {
              setReportData(prev => {
                const newData = {...prev};
                
                if (!newData[region]) {
                  newData[region] = {
                    total: 0,
                    landSizeTotal: 0,
                    bySmmetype: {}
                  };
                }
                
                if (!newData[region].bySmmetype[smmeType]) {
                  newData[region].bySmmetype[smmeType] = {
                    count: 0,
                    landSizeTotal: 0
                  };
                }
                
                newData[region].total += 1;
                newData[region].landSizeTotal += landSize;
                newData[region].bySmmetype[smmeType].count += 1;
                newData[region].bySmmetype[smmeType].landSizeTotal += landSize;
                
                return newData;
              });
              
              updateStats(selection.COUNTRY || country, region, smmeType, landSize);
            }
          }
        });
    
        return () => unsubscribe();
      }, [country]);
    
      const fullRegionMap = getRegionMap(selectedCountry);
      const allRegions = Object.keys(fullRegionMap)
        .filter(region => !region.startsWith('-'));
    
      const chunkSize = 9;
      const regionChunks = [];
    
      for (let i = 0; i < allRegions.length; i += chunkSize) {
        const chunk = allRegions.slice(i, i + chunkSize);
        while (chunk.length < chunkSize) {
          chunk.push(``);
        }
        regionChunks.push(chunk);
      }
    
      const getRegionName = (regionData, country = 'South Africa') => {
        if (!regionData) return null;
        
        if (country === 'South Africa') {
          const regionMap = {
            "Gauteng": "013",
            "Eastern Cape": "032", 
            "Limpopo": "033",
            "KwaZulu-Natal": "044",
            "Mpumalanga": "035",
            "Western Cape": "036",
            "North West": "037",
            "Northern Cape": "038",
            "Free State": "309"
          };
          
          if (typeof regionData === 'object') {
            if (regionData.name) {
              return regionData.name;
            }
            return Object.keys(regionMap).find(key => 
              regionMap[key] === regionData.value
            ) || regionData;
          }
          
          if (typeof regionData === 'string') {
            return Object.keys(regionMap).find(key => 
              key.toLowerCase() === regionData.toLowerCase()
            ) || regionData;
          }
        }
        
        return typeof regionData === 'object' ? regionData.name : regionData;
      };
    
      const countryMapImages = {
        'Angola': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444884/Angola_Map_qri8d9.jpg',
        'Botswana': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444904/Botswana_Map_ixujke.jpg',
        'Cameroon': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444883/Cameroon_Map_oli1ea.jpg',
        'Côte d\'Ivoire (Ivory Coast)': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444885/Cote_D_Ivorie_Map_titbtu.jpg',
        'Congo (Kinshasa/DRC)': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444894/Congo_DRC_map_eooyiv.jpg',
        'Eswatini': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444890/Eswatini_Map_qg49ik.jpg',
        'Ethiopia': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444894/Ethiopia_map_ijxizh.jpg',
        'Ghana': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444895/Ghana_Map_at9tji.jpg',
        'Kenya': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444894/Kenya_Map_axuptr.jpg',
        'Lesotho': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444894/Lesotho_Map_wwweao.jpg',
        'Malawi': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444895/Malawi_Map_cezzt0.jpg',
        'Mozambique': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444889/Mozambique_map_mr5gti.jpg',
        'Namibia': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444889/Namibia_Map_i2r8th.jpg',
        'Nigeria': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444890/Nigeria_Map_fyxypv.jpg',
        'Rwanda': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750447501/Rwanda_Map_dslxiy.jpg',
        'Senegal': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444882/Senegal_Map_gbxrbb.jpg',
        'Somalia': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444942/Somalia_Map_xwxy02.jpg',
        'South Africa': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444882/South_Africa_map_fhljpi.jpg',
        'South Sudan': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444882/South_Sudan_Map_ox0wyh.jpg',
        'Tanzania': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750447501/Tanzania_map_pwlaay.jpg',
        'Uganda': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444883/Uganda_map_rrjk9p.jpg',
        'Zambia': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444885/Zambia_Map_izofpt.jpg'
      };
    
      const getSmmetype = (smmeData) => {
        if (!smmeData) return null;
        if (typeof smmeData === 'string') return smmeData;
        return smmeData.value || null;
      };
    
      const getCount = (region, key, field = 'count') => {
        if (region === "-" || region.startsWith('-') || !reportData || !reportData[region]) {
          return 0;
        }
        
        if (!key) {
          return reportData[region][field] || 0;
        }
        
        const validCategories = ['ESC', 'EMS', 'EFC', 'ECF', 'ENS', 'EAE', 'EYW', 'OTHERS'];
        if (!validCategories.includes(key)) {
          return 0;
        }
        
        return reportData[region].bySmmetype[key]?.[field] || 0;
      };
    
      const getTotalForAllRegions = (key, field = 'count', currentChunkRegions) => {
        if (!reportData) return 0;
        
        let total = 0;
        currentChunkRegions.forEach(region => {
          if (region === "-" || region.startsWith('-')) return;
          
          const count = getCount(region, key, field);
          if (typeof count === 'number' && !isNaN(count)) {
            total += count;
          }
        });
        return total;
      };
    
      useEffect(() => {
        const fetchData = async (selection) => {
          try {
            setLoading(true);
            
            const statsDoc = await getDoc(doc(db, "stats", "registrations"));
            if (statsDoc.exists()) {
              setReportData(statsDoc.data());
              setLoading(false);
              return;
            }
      
            const registrationsSnapshot = await getDocs(collection(db, "registrations"));
            
            const data = {};
            const allRegions = Object.keys(getRegionMap(selectedCountry));
            
            allRegions.forEach(region => {
              data[region] = {
                total: 0,
                landSizeTotal: 0,
                bySmmetype: {}
              };
                   const q = query(
                collection(db, "registrations"),
                where("country", "==", country.name)
              );
              SMMEsOptions.forEach(category => {
                category.items.forEach(item => {
                  data[region].bySmmetype[item.value] = {
                    count: 0,
                    landSizeTotal: 0
                  };
                });
              });
            });
      
            registrationsSnapshot.forEach(doc => {
              const regData = doc.data();
              const regionName = getRegionName(regData.REGION, selectedCountry);
              
              if (!regionName || !data[regionName]) return;
      
              const landSize = 
                (regData.landData?.type1?.size || 0) + 
                (regData.landData?.type2?.size || 0);
      
              const smmeType = regData.SMMEs?.value || regData.SMMEs;
              
              data[regionName].total += 1;
              data[regionName].landSizeTotal += landSize;
      
              if (smmeType) {
                if (!data[regionName].bySmmetype[smmeType]) {
                  data[regionName].bySmmetype[smmeType] = {
                    count: 0,
                    landSizeTotal: 0
                  };
                }
                
                data[regionName].bySmmetype[smmeType].count += 1;
                data[regionName].bySmmetype[smmeType].landSizeTotal += landSize;
              }
            });
      
            setReportData(data);
          } catch (error) {
            console.error("Error fetching reports:", error);
            setError("Failed to load report data");
          } finally {
            setLoading(false);
          }
        };
      
        fetchData();
      }, [selectedCountry]);
    
      useEffect(() => {
        const unsubscribe = onSnapshot(doc(db, "registrations", "current_selection"), (doc) => {
          if (doc.exists()) {
            const selection = doc.data();
            setReportSelections(prev => ({
              ...prev,
              ...selection
            }));
            
            const region = getRegionName(selection.REGION, selection.COUNTRY || country);
            const smmeType = selection.SMMEs?.value || selection.SMMEs;
            
            if (region && smmeType) {
              setReportData(prev => {
                const newData = {...prev};
                
                if (!newData[region]) {
                  newData[region] = {
                    total: 0,
                    landSizeTotal: 0,
                    bySmmetype: {}
                  };
                }
                
                if (!newData[region].bySmmetype[smmeType]) {
                  newData[region].bySmmetype[smmeType] = {
                    count: 0,
                    landSizeTotal: 0
                  };
                }
                
                newData[region].total += 1;
                newData[region].bySmmetype[smmeType].count += 1;
                
                return newData;
              });
            }
          }
        });
    
        return () => unsubscribe();
      }, [country]);
    
      const totalEntrepreneurs = useMemo(() => {
        if (!reportData) return 0;
        return Object.keys(reportData).reduce((sum, region) => {
          return sum + (reportData[region]?.total || 0);
        }, 0);
      }, [reportData]);
    
      useEffect(() => {
        onTotalCalculated(totalEntrepreneurs);
      }, [totalEntrepreneurs, onTotalCalculated]);
    
      const fetchData = async () => {
        try {
          setLoading(true);
          
          const q = query(
            collection(db, "registrations"),
            where("COUNTRY", "==", selectedCountry)
          );
          
          const registrationsSnapshot = await getDocs(q);
          
          const data = {};
          const allRegions = Object.keys(getRegionMap(selectedCountry));
          
          allRegions.forEach(region => {
            data[region] = {
              total: 0,
              landSizeTotal: 0,
              bySmmetype: {
                'ESC': { count: 0, landSizeTotal: 0 },
                'EMS': { count: 0, landSizeTotal: 0 },
                'EFC': { count: 0, landSizeTotal: 0 },
                'ECF': { count: 0, landSizeTotal: 0 },
                'ENS': { count: 0, landSizeTotal: 0 },
                'EAE': { count: 0, landSizeTotal: 0 },
                'EYW': { count: 0, landSizeTotal: 0 },
                'OTHERS': { count: 0, landSizeTotal: 0 }
              }
            };
          });
    
          registrationsSnapshot.forEach(doc => {
            const regData = doc.data();
            const regionName = getRegionName(regData.REGION, selectedCountry);
            
            if (!regionName || !data[regionName]) return;
    
            const landSize = 
              (regData.landData?.type1?.size || 0) + 
              (regData.landData?.type2?.size || 0);
    
            const smmeType = regData.SMMEs?.value || regData.SMMEs || 'OTHERS';
            
            if (!data[regionName].bySmmetype[smmeType]) {
              data[regionName].bySmmetype[smmeType] = {
                count: 0,
                landSizeTotal: 0
              };
            }
            
            data[regionName].total += 1;
            data[regionName].landSizeTotal += landSize;
            data[regionName].bySmmetype[smmeType].count += 1;
            data[regionName].bySmmetype[smmeType].landSizeTotal += landSize;
          });
    
          setReportData(data);
        } catch (error) {
          console.error("Error fetching reports:", error);
          setError("Failed to load report data");
        } finally {
          setLoading(false);
        }
      };
    
      useEffect(() => {
        const fetchData = async () => {
          try {
            setLoading(true);
            
            let queryConstraints = [];
            
            if (reportSelections.COUNTRY) {
              queryConstraints.push(where("COUNTRY", "==", reportSelections.COUNTRY));
            }
            
            if (reportSelections.REGION && reportSelections.REGION !== "-") {
              queryConstraints.push(where("REGION", "==", reportSelections.REGION));
            }
            
            if (reportSelections.SMMEs && reportSelections.SMMEs !== "-") {
              const smmeValue = typeof reportSelections.SMMEs === 'object' ? 
                reportSelections.SMMEs.value : reportSelections.SMMEs;
              queryConstraints.push(where("SMMEs", "==", smmeValue));
            }
            
            const q = query(collection(db, "registrations"), ...queryConstraints);
            await getDocs(q);
            
          } catch (error) {
            console.error("Error fetching data:", error);
            setError("Failed to load data");
          } finally {
            setLoading(false);
          }
        };
        
        fetchData();
      }, [reportSelections]);
    
      useEffect(() => {
        if (reportSelections.REGION && reportSelections.REGION !== "-") {
          const regionName = getRegionName(reportSelections.REGION, reportSelections.COUNTRY);
          const regionData = reportData?.[regionName];
          setFilteredTotal(regionData?.total || 0);
        } else {
          const countryTotal = Object.keys(reportData || {}).reduce((sum, region) => {
            return sum + (reportData[region]?.total || 0);
          }, 0);
          setFilteredTotal(countryTotal);
        }
      }, [reportSelections.REGION, reportSelections.COUNTRY, reportData]);
    
      useEffect(() => {
        onTotalCalculated(filteredTotal);
      }, [filteredTotal, onTotalCalculated]);
    
      useEffect(() => {
        if (reportData) {
          const total = regionChunks.reduce((total, chunk) => {
            return total + chunk.reduce((chunkTotal, region) => {
              return chunkTotal + (reportData[region]?.total || 0);
            }, 0);
          }, 0);
          setCurrentChunkTotal(total);
          onTotalCalculated(total);
        }
      }, [reportData, regionChunks]);
    
      useEffect(() => {
        if (reportData) {
          const total = Object.values(reportData).reduce((sum, region) => {
            return sum + (region?.total || 0);
          }, 0);
          setTotalRegistrations(total);
          onTotalCalculated(total);
        }
      }, [reportData]);
    
      if (loading) return <div>Loading report data...</div>;
      if (error) return <div>Error: {error}</div>;
      if (!reportData) return <div>No report data available</div>;
    
      const sections = [
       
        {
          title: "",
          items: [
            {label: 'Smallholder Commercial Farms (ESC)', key: 'ESC',},
            {label: 'Land size (HA)', key: 'ESC', field: 'landSizeTotal', color: '#3F8325'},
          ]
        },
        {
          title: "",
          items: [
            {label: 'Medium-Scale Farms (EMS)', key: 'EMS', },
            {label: 'Land size (HA)',key: 'EMS', color: '#03897B'},
          ]
        },
        {
          title: "",
          items: [
            {label: 'Farmer Cooperatives/Producer Organizations (EFC)', key: 'EFC',},
            {label: 'Land size (HA)', key: 'EFC', color: '#CADF4E'},
          ]
        },
        {
          title: "",
          items: [
            {label: 'Contract Farming SMEs (ECF)', key: 'ECF', },
            {label: 'Land size (HA)',  key: 'ECF', color: '#152C24'},
          ]
        },
        {
          title: "",
          items: [
            {label: 'Niche or Specialized Farms (ENS)', key: 'ENS', },
            {label: 'Land size (HA)', key: 'ENS', color: '#F23939'},
          ]
        },
        {
          title: "",
          items: [
            {label: 'Agri-Entrepreneurs with Integrated Operations (EAE)', key: 'EAE', },
            {label: 'Land size (HA)', key: 'EAE', color: '#C4C4C4'},
          ]
        },
        {
          title: "",
          items: [
            {label: 'Youth or Women-led Farming Startups (EYW)', key: 'EYW', },
            {label: 'Land size (HA)', key: 'EYW', color: '#000000'},
          ]
        },
      ];
      
      return (
        <div className="mb-6 md:mt-10 mt-3">
        {(() => {
          const totalEntrepreneurs = regionChunks.reduce((total, chunk) => {
            return total + chunk.reduce((chunkTotal, region) => {
              return chunkTotal + (reportData[region]?.total || 0);
            }, 0);
          }, 0);
          
          return (
            <div className="hidden" data-total={totalEntrepreneurs}></div>
          );
        })()}
        
        {regionChunks.map((regionChunk, chunkIndex) => (
          <div key={`chunk-${chunkIndex}`} className="mb-8">
            <div className="flex md:flex-row items-start gap-1 md:gap-2">
              <div className="w-[90px] md:w-[220px]">
                <p className="h-4 md:h-7 text-[#152C24] rounded-md text-[5px] md:text-[16px] font-bold">AGRICULTURAL SMMEs</p>
              </div>
              <p className="h-4 md:h-7 text-[#152C24] rounded-md text-[4px] md:text-[16px] font-bold">TOTAL</p>
  
              <div className="grid grid-cols-9 md:grid-cols-9 md:gap-[10px] gap-[20px] flex-1">
                {regionChunk.map((region, i) => (
                  <div key={i} className="text-[4px] md:text-[14px] rounded-[5px] text-black font-extrabold px-1 text-center md:w-[100px]">
                    {region}
                  </div>
                ))}
              </div>
            </div>
            
            <p className="text-[#152C24] font-bold mb-2 text-[10px] md:text-[14px]">TOTAL</p>
            <div className="mt-2">
              <div className='md:h-[2px] h-[1px] bg-black'></div>
  
              {/* Agricultural Entrepreneurs Row */}
              <div className="overflow-x-auto">
                <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[120px_repeat(9,1fr)] gap-y-1 gap-x-1 md:gap-x-2 mt-2 md:mt-3">
                  <div className="flex items-center gap-1 md:w-[300px]">
                    <div className="text-[6px] md:text-[14px] text-black w-[180px] font-bold leading-tight">
                      Agricultural Entrepreneurs
                    </div>
                    <div className="md:w-[34px] w-[15px] h-[15px] md:h-[34px] bg-[#FFBD26] rounded-full cursor-pointer"/>
                    <div className="h-4 md:h-7 text-[#152C24] md:ml-[30px] ml-[25px] font-bold rounded-md text-[5px] md:text-[14px] flex items-center justify-center">
                      {getTotalForAllRegions(null, 'total', regionChunk)}
                    </div>
                  </div>
                  {regionChunk.map((region, j) => (
                    <div
                      key={`total-${j}`}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center font-bold"
                    >
                      {getCount(region, null, 'total')}
                    </div>
                  ))}
                </div>
              </div>
            </div>
  
            {/* Land for Farming Row */}
            <div >
              <div className="overflow-x-auto">
                <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[120px_repeat(9,1fr)] gap-y-1 gap-x-1 md:gap-x-2 mt-2 md:mt-3">
                  <div className="flex items-center gap-[34px]">
                    <div className="text-[6px] md:text-[14px] w-[150px] text-black font-bold leading-tight">
                      Land for Farming (Ha)
                    </div>
                    <div className="md:w-[34px] w-[15px] h-[15px] md:h-[34px] bg-[#2E453D] rounded-full cursor-pointer"/>
                    <div className="h-4 md:h-7 text-[#152C24] rounded-md font-bold text-[5px] md:text-[14px] flex items-center justify-center">
                      {regionChunk.reduce((total, region) => {
                        return total + (reportData[region]?.landSizeTotal || 0);
                      }, 0)}
                    </div>
                  </div>
                  {regionChunk.map((region) => (
                    <div 
                      key={`total-${region}`}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center font-normal"
                    >
                      {reportData[region]?.landSizeTotal || 0}
                    </div>
                  ))}
                </div>
              </div>
            </div>
  
            {/* Production Cost Row */}
            <div className="md:mt-9 mt-2">
              <div className="overflow-x-auto">
                <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[120px_repeat(9,1fr)] gap-y-1 gap-x-1 md:gap-x-2 mt-2 md:mt-3">
                  <div className="flex items-center gap-8 w-[280px]">
                    <div className="text-[6px] md:text-[14px] text-black w-[120px] font-bold leading-tight">
                      Production Cost
                    </div>
                    <div className="md:w-[34px] w-[15px] h-[15px] md:h-[34px] bg-[#9FAFAF] ml-8 rounded-full cursor-pointer"/>
                    <div className="h-4 md:h-7 text-[#152C24] rounded-md font-bold text-[5px] md:text-[14px] flex items-center justify-center">
                      {getTotalForAllRegions(null, 'total', regionChunk)}
                    </div>
                  </div>
                  {regionChunk.map((region, j) => (
                    <div
                      key={`total-${j}`}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center font-normal"
                    >
                      {getCount(region, null, 'total')}
                    </div>
                  ))}
                </div>
              </div>
            </div>
  
            {/* Revenue Row */}
            <div >
              <div className="overflow-x-auto">
                <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[120px_repeat(9,1fr)] gap-y-1 gap-x-1 md:gap-x-2 mt-2 md:mt-3">
                  <div className="flex items-center gap-8 w-[300px]">
                    <div className="text-[6px] md:text-[14px] text-black w-[120px] font-bold leading-tight">
                      Revenue
                    </div>
                    <div className="md:w-[34px] w-[15px] h-[15px] md:h-[34px] bg-[#CFD7D7] ml-8 rounded-full cursor-pointer"/>
                    <div className="h-4 md:h-7 text-[#152C24] rounded-md text-[5px] font-bold md:text-[14px] flex items-center justify-center">
                      {getTotalForAllRegions(null, 'total', regionChunk)}
                    </div>
                  </div>
                  {regionChunk.map((region, j) => (
                    <div
                      key={`total-${j}`}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center font-normal"
                    >
                      {getCount(region, null, 'total')}
                    </div>
                  ))}
                </div>
              </div>
            </div>
  
            {/* Inventory Row */}
            <div >
              <div className="overflow-x-auto">
                <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[120px_repeat(9,1fr)] gap-y-1 gap-x-1 md:gap-x-2 mt-2 md:mt-3">
                  <div className="flex items-center gap-8 w-[280px]">
                    <div className="text-[6px] md:text-[14px] text-black w-[120px] font-bold leading-tight">
                      Inventory
                    </div>
                    <div className="md:w-[34px] w-[15px] h-[15px] md:h-[34px] bg-[#8EC543] ml-8 rounded-full cursor-pointer"/>
                    <div className="h-4 md:h-7 text-[#152C24] rounded-md font-bold text-[5px] md:text-[14px] flex items-center justify-center">
                      {getTotalForAllRegions(null, 'total', regionChunk)}
                    </div>
                  </div>
                  {regionChunk.map((region, j) => (
                    <div
                      key={`total-${j}`}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center font-normal"
                    >
                      {getCount(region, null, 'total')}
                    </div>
                  ))}
                </div>
              </div>
            </div>
  
            {/* Price (Average) Row */}
            <div >
              <div className="overflow-x-auto">
                <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[120px_repeat(9,1fr)] gap-y-1 gap-x-1 md:gap-x-2 mt-2 md:mt-3">
                  <div className="flex items-center gap-8 w-[300px]">
                    <div className="text-[6px] md:text-[14px] text-black w-[120px] font-bold leading-tight">
                      Price (Average)
                    </div>
                    <div className="md:w-[34px] w-[15px] h-[15px] md:h-[34px] bg-[#F23939] ml-8 rounded-full cursor-pointer"/>
                    <div className="h-4 md:h-7 text-[#152C24] rounded-md text-[5px] font-bold md:text-[14px] flex items-center justify-center">
                      {getTotalForAllRegions(null, 'total', regionChunk)}
                    </div>
                  </div>
                  {regionChunk.map((region, j) => (
                    <div
                      key={`total-${j}`}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center font-normal"
                    >
                      {getCount(region, null, 'total')}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      );
    };
    const EnterpriseSection1 = ({ regions, country, onTotalCalculated }) => {
      const [reportData, setReportData] = useState(null);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);
      const [totalRegistrations, setTotalRegistrations] = useState(0);
      const location = useLocation();
      const queryParams = new URLSearchParams(location.search);
      const selectedCountry = queryParams.get('country') || country?.name || 'South Africa';
      const [currentChunkTotal, setCurrentChunkTotal] = useState(0);
      const [reportSelections, setReportSelections] = useState({
        COUNTRY: "-",
        REGION: "-",
        DISTRICT: "-",
        MUNICIPALITY: "-",
        SMMEs: "-",
        "VALUE CHAIN": "-",
        PROJECT: "-",
        "USER TYPE": "-"
      });
      const [filteredTotal, setFilteredTotal] = useState(0);
    
      const updateStats = async (country, region, smmeType, landSize) => {
        const statsRef = doc(db, "stats", "registrations");
        
        try {
          await runTransaction(db, async (transaction) => {
            const statsDoc = await transaction.get(statsRef);
            let statsData = statsDoc.exists() ? statsDoc.data() : {};
            
            const countryKey = country === 'South Africa' ? 'South Africa' : country;
            
            if (!statsData[countryKey]) {
              statsData[countryKey] = {};
            }
            
            const regionKey = country === 'South Africa' 
              ? getRegionName(region, 'South Africa')
              : region;
            
            if (!statsData[countryKey][regionKey]) {
              statsData[countryKey][regionKey] = {
                total: 0,
                landSizeTotal: 0,
                bySmmetype: {}
              };
            }
            
            if (!statsData[countryKey][regionKey].bySmmetype[smmeType]) {
              statsData[countryKey][regionKey].bySmmetype[smmeType] = {
                count: 0,
                landSizeTotal: 0
              };
            }
            
            statsData[countryKey][regionKey].total = 
              (statsData[countryKey][regionKey].total || 0) + 1;
            statsData[countryKey][regionKey].landSizeTotal = 
              (statsData[countryKey][regionKey].landSizeTotal || 0) + landSize;
            statsData[countryKey][regionKey].bySmmetype[smmeType].count = 
              (statsData[countryKey][regionKey].bySmmetype[smmeType].count || 0) + 1;
            statsData[countryKey][regionKey].bySmmetype[smmeType].landSizeTotal = 
              (statsData[countryKey][regionKey].bySmmetype[smmeType].landSizeTotal || 0) + landSize;
            
            transaction.set(statsRef, statsData);
          });
        } catch (error) {
          console.error("Transaction failed:", error);
        }
      };
    
      useEffect(() => {
        const unsubscribe = onSnapshot(doc(db, "registrations", "current_selection"), (doc) => {
          if (doc.exists()) {
            const selection = doc.data();
            const region = getRegionName(selection.REGION, selection.COUNTRY || country);
            const smmeType = selection.SMMEs?.value || selection.SMMEs;
            const landSize = (selection.landData?.type1?.size || 0) + (selection.landData?.type2?.size || 0);
            
            if (region && smmeType) {
              setReportData(prev => {
                const newData = {...prev};
                
                if (!newData[region]) {
                  newData[region] = {
                    total: 0,
                    landSizeTotal: 0,
                    bySmmetype: {}
                  };
                }
                
                if (!newData[region].bySmmetype[smmeType]) {
                  newData[region].bySmmetype[smmeType] = {
                    count: 0,
                    landSizeTotal: 0
                  };
                }
                
                newData[region].total += 1;
                newData[region].landSizeTotal += landSize;
                newData[region].bySmmetype[smmeType].count += 1;
                newData[region].bySmmetype[smmeType].landSizeTotal += landSize;
                
                return newData;
              });
              
              updateStats(selection.COUNTRY || country, region, smmeType, landSize);
            }
          }
        });
    
        return () => unsubscribe();
      }, [country]);
    
      const fullRegionMap = getRegionMap(selectedCountry);
      const allRegions = Object.keys(fullRegionMap)
        .filter(region => !region.startsWith('-'));
    
      const chunkSize = 9;
      const regionChunks = [];
    
      for (let i = 0; i < allRegions.length; i += chunkSize) {
        const chunk = allRegions.slice(i, i + chunkSize);
        while (chunk.length < chunkSize) {
          chunk.push(``);
        }
        regionChunks.push(chunk);
      }
    
      const getRegionName = (regionData, country = 'South Africa') => {
        if (!regionData) return null;
        
        if (country === 'South Africa') {
          const regionMap = {
            "Gauteng": "013",
            "Eastern Cape": "032", 
            "Limpopo": "033",
            "KwaZulu-Natal": "044",
            "Mpumalanga": "035",
            "Western Cape": "036",
            "North West": "037",
            "Northern Cape": "038",
            "Free State": "309"
          };
          
          if (typeof regionData === 'object') {
            if (regionData.name) {
              return regionData.name;
            }
            return Object.keys(regionMap).find(key => 
              regionMap[key] === regionData.value
            ) || regionData;
          }
          
          if (typeof regionData === 'string') {
            return Object.keys(regionMap).find(key => 
              key.toLowerCase() === regionData.toLowerCase()
            ) || regionData;
          }
        }
        
        return typeof regionData === 'object' ? regionData.name : regionData;
      };
    
      const countryMapImages = {
        'Angola': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444884/Angola_Map_qri8d9.jpg',
        'Botswana': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444904/Botswana_Map_ixujke.jpg',
        'Cameroon': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444883/Cameroon_Map_oli1ea.jpg',
        'Côte d\'Ivoire (Ivory Coast)': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444885/Cote_D_Ivorie_Map_titbtu.jpg',
        'Congo (Kinshasa/DRC)': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444894/Congo_DRC_map_eooyiv.jpg',
        'Eswatini': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444890/Eswatini_Map_qg49ik.jpg',
        'Ethiopia': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444894/Ethiopia_map_ijxizh.jpg',
        'Ghana': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444895/Ghana_Map_at9tji.jpg',
        'Kenya': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444894/Kenya_Map_axuptr.jpg',
        'Lesotho': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444894/Lesotho_Map_wwweao.jpg',
        'Malawi': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444895/Malawi_Map_cezzt0.jpg',
        'Mozambique': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444889/Mozambique_map_mr5gti.jpg',
        'Namibia': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444889/Namibia_Map_i2r8th.jpg',
        'Nigeria': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444890/Nigeria_Map_fyxypv.jpg',
        'Rwanda': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750447501/Rwanda_Map_dslxiy.jpg',
        'Senegal': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444882/Senegal_Map_gbxrbb.jpg',
        'Somalia': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444942/Somalia_Map_xwxy02.jpg',
        'South Africa': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444882/South_Africa_map_fhljpi.jpg',
        'South Sudan': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444882/South_Sudan_Map_ox0wyh.jpg',
        'Tanzania': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750447501/Tanzania_map_pwlaay.jpg',
        'Uganda': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444883/Uganda_map_rrjk9p.jpg',
        'Zambia': 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750444885/Zambia_Map_izofpt.jpg'
      };
    
      const getSmmetype = (smmeData) => {
        if (!smmeData) return null;
        if (typeof smmeData === 'string') return smmeData;
        return smmeData.value || null;
      };
    
      const getCount = (region, key, field = 'count') => {
        if (region === "-" || region.startsWith('-') || !reportData || !reportData[region]) {
          return 0;
        }
        
        if (!key) {
          return reportData[region][field] || 0;
        }
        
        const validCategories = ['ESC', 'EMS', 'EFC', 'ECF', 'ENS', 'EAE', 'EYW', 'OTHERS'];
        if (!validCategories.includes(key)) {
          return 0;
        }
        
        return reportData[region].bySmmetype[key]?.[field] || 0;
      };
    
      const getTotalForAllRegions = (key, field = 'count', currentChunkRegions) => {
        if (!reportData) return 0;
        
        let total = 0;
        currentChunkRegions.forEach(region => {
          if (region === "-" || region.startsWith('-')) return;
          
          const count = getCount(region, key, field);
          if (typeof count === 'number' && !isNaN(count)) {
            total += count;
          }
        });
        return total;
      };
    
      useEffect(() => {
        const fetchData = async (selection) => {
          try {
            setLoading(true);
            
            const statsDoc = await getDoc(doc(db, "stats", "registrations"));
            if (statsDoc.exists()) {
              setReportData(statsDoc.data());
              setLoading(false);
              return;
            }
      
            const registrationsSnapshot = await getDocs(collection(db, "registrations"));
            
            const data = {};
            const allRegions = Object.keys(getRegionMap(selectedCountry));
            
            allRegions.forEach(region => {
              data[region] = {
                total: 0,
                landSizeTotal: 0,
                bySmmetype: {}
              };
                   const q = query(
                collection(db, "registrations"),
                where("country", "==", country.name)
              );
              SMMEsOptions.forEach(category => {
                category.items.forEach(item => {
                  data[region].bySmmetype[item.value] = {
                    count: 0,
                    landSizeTotal: 0
                  };
                });
              });
            });
      
            registrationsSnapshot.forEach(doc => {
              const regData = doc.data();
              const regionName = getRegionName(regData.REGION, selectedCountry);
              
              if (!regionName || !data[regionName]) return;
      
              const landSize = 
                (regData.landData?.type1?.size || 0) + 
                (regData.landData?.type2?.size || 0);
      
              const smmeType = regData.SMMEs?.value || regData.SMMEs;
              
              data[regionName].total += 1;
              data[regionName].landSizeTotal += landSize;
      
              if (smmeType) {
                if (!data[regionName].bySmmetype[smmeType]) {
                  data[regionName].bySmmetype[smmeType] = {
                    count: 0,
                    landSizeTotal: 0
                  };
                }
                
                data[regionName].bySmmetype[smmeType].count += 1;
                data[regionName].bySmmetype[smmeType].landSizeTotal += landSize;
              }
            });
      
            setReportData(data);
          } catch (error) {
            console.error("Error fetching reports:", error);
            setError("Failed to load report data");
          } finally {
            setLoading(false);
          }
        };
      
        fetchData();
      }, [selectedCountry]);
    
      useEffect(() => {
        const unsubscribe = onSnapshot(doc(db, "registrations", "current_selection"), (doc) => {
          if (doc.exists()) {
            const selection = doc.data();
            setReportSelections(prev => ({
              ...prev,
              ...selection
            }));
            
            const region = getRegionName(selection.REGION, selection.COUNTRY || country);
            const smmeType = selection.SMMEs?.value || selection.SMMEs;
            
            if (region && smmeType) {
              setReportData(prev => {
                const newData = {...prev};
                
                if (!newData[region]) {
                  newData[region] = {
                    total: 0,
                    landSizeTotal: 0,
                    bySmmetype: {}
                  };
                }
                
                if (!newData[region].bySmmetype[smmeType]) {
                  newData[region].bySmmetype[smmeType] = {
                    count: 0,
                    landSizeTotal: 0
                  };
                }
                
                newData[region].total += 1;
                newData[region].bySmmetype[smmeType].count += 1;
                
                return newData;
              });
            }
          }
        });
    
        return () => unsubscribe();
      }, [country]);
    
      const totalEntrepreneurs = useMemo(() => {
        if (!reportData) return 0;
        return Object.keys(reportData).reduce((sum, region) => {
          return sum + (reportData[region]?.total || 0);
        }, 0);
      }, [reportData]);
    
      useEffect(() => {
        onTotalCalculated(totalEntrepreneurs);
      }, [totalEntrepreneurs, onTotalCalculated]);
    
      const fetchData = async () => {
        try {
          setLoading(true);
          
          const q = query(
            collection(db, "registrations"),
            where("COUNTRY", "==", selectedCountry)
          );
          
          const registrationsSnapshot = await getDocs(q);
          
          const data = {};
          const allRegions = Object.keys(getRegionMap(selectedCountry));
          
          allRegions.forEach(region => {
            data[region] = {
              total: 0,
              landSizeTotal: 0,
              bySmmetype: {
                'ESC': { count: 0, landSizeTotal: 0 },
                'EMS': { count: 0, landSizeTotal: 0 },
                'EFC': { count: 0, landSizeTotal: 0 },
                'ECF': { count: 0, landSizeTotal: 0 },
                'ENS': { count: 0, landSizeTotal: 0 },
                'EAE': { count: 0, landSizeTotal: 0 },
                'EYW': { count: 0, landSizeTotal: 0 },
                'OTHERS': { count: 0, landSizeTotal: 0 }
              }
            };
          });
    
          registrationsSnapshot.forEach(doc => {
            const regData = doc.data();
            const regionName = getRegionName(regData.REGION, selectedCountry);
            
            if (!regionName || !data[regionName]) return;
    
            const landSize = 
              (regData.landData?.type1?.size || 0) + 
              (regData.landData?.type2?.size || 0);
    
            const smmeType = regData.SMMEs?.value || regData.SMMEs || 'OTHERS';
            
            if (!data[regionName].bySmmetype[smmeType]) {
              data[regionName].bySmmetype[smmeType] = {
                count: 0,
                landSizeTotal: 0
              };
            }
            
            data[regionName].total += 1;
            data[regionName].landSizeTotal += landSize;
            data[regionName].bySmmetype[smmeType].count += 1;
            data[regionName].bySmmetype[smmeType].landSizeTotal += landSize;
          });
    
          setReportData(data);
        } catch (error) {
          console.error("Error fetching reports:", error);
          setError("Failed to load report data");
        } finally {
          setLoading(false);
        }
      };
    
      useEffect(() => {
        const fetchData = async () => {
          try {
            setLoading(true);
            
            let queryConstraints = [];
            
            if (reportSelections.COUNTRY) {
              queryConstraints.push(where("COUNTRY", "==", reportSelections.COUNTRY));
            }
            
            if (reportSelections.REGION && reportSelections.REGION !== "-") {
              queryConstraints.push(where("REGION", "==", reportSelections.REGION));
            }
            
            if (reportSelections.SMMEs && reportSelections.SMMEs !== "-") {
              const smmeValue = typeof reportSelections.SMMEs === 'object' ? 
                reportSelections.SMMEs.value : reportSelections.SMMEs;
              queryConstraints.push(where("SMMEs", "==", smmeValue));
            }
            
            const q = query(collection(db, "registrations"), ...queryConstraints);
            await getDocs(q);
            
          } catch (error) {
            console.error("Error fetching data:", error);
            setError("Failed to load data");
          } finally {
            setLoading(false);
          }
        };
        
        fetchData();
      }, [reportSelections]);
    
      useEffect(() => {
        if (reportSelections.REGION && reportSelections.REGION !== "-") {
          const regionName = getRegionName(reportSelections.REGION, reportSelections.COUNTRY);
          const regionData = reportData?.[regionName];
          setFilteredTotal(regionData?.total || 0);
        } else {
          const countryTotal = Object.keys(reportData || {}).reduce((sum, region) => {
            return sum + (reportData[region]?.total || 0);
          }, 0);
          setFilteredTotal(countryTotal);
        }
      }, [reportSelections.REGION, reportSelections.COUNTRY, reportData]);
    
      useEffect(() => {
        onTotalCalculated(filteredTotal);
      }, [filteredTotal, onTotalCalculated]);
    
      useEffect(() => {
        if (reportData) {
          const total = regionChunks.reduce((total, chunk) => {
            return total + chunk.reduce((chunkTotal, region) => {
              return chunkTotal + (reportData[region]?.total || 0);
            }, 0);
          }, 0);
          setCurrentChunkTotal(total);
          onTotalCalculated(total);
        }
      }, [reportData, regionChunks]);
    
      useEffect(() => {
        if (reportData) {
          const total = Object.values(reportData).reduce((sum, region) => {
            return sum + (region?.total || 0);
          }, 0);
          setTotalRegistrations(total);
          onTotalCalculated(total);
        }
      }, [reportData]);
    
      if (loading) return <div>Loading report data...</div>;
      if (error) return <div>Error: {error}</div>;
      if (!reportData) return <div>No report data available</div>;
    
      const sections = [
       
        {
          title: "",
          items: [
            {label: 'Smallholder Commercial Farms (ESC)', key: 'ESC',},
            {label: 'Land size (HA)', key: 'ESC', field: 'landSizeTotal', color: '#3F8325'},
          ]
        },
        {
          title: "",
          items: [
            {label: 'Medium-Scale Farms (EMS)', key: 'EMS', },
            {label: 'Land size (HA)',key: 'EMS', color: '#03897B'},
          ]
        },
        {
          title: "",
          items: [
            {label: 'Farmer Cooperatives/Producer Organizations (EFC)', key: 'EFC',},
            {label: 'Land size (HA)', key: 'EFC', color: '#CADF4E'},
          ]
        },
        {
          title: "",
          items: [
            {label: 'Contract Farming SMEs (ECF)', key: 'ECF', },
            {label: 'Land size (HA)',  key: 'ECF', color: '#8EC543'},
          ]
        },
        {
          title: "",
          items: [
            {label: 'Niche or Specialized Farms (ENS)', key: 'ENS', },
            {label: 'Land size (HA)', key: 'ENS', color: '#F7B030'},
          ]
        },
        {
          title: "",
          items: [
            {label: 'Agri-Entrepreneurs with Integrated Operations (EAE)', key: 'EAE', },
            {label: 'Land size (HA)', key: 'EAE', color: '#C4C4C4'},
          ]
        },
        {
          title: "",
          items: [
            {label: 'Youth or Women-led Farming Startups (EYW)', key: 'EYW', },
            {label: 'Land size (HA)', key: 'EYW', color: '#000000'},
          ]
        },
      ];
      
      return (
        <div className="mb-6 md:mt-10 mt-3">
        {(() => {
          const totalEntrepreneurs = regionChunks.reduce((total, chunk) => {
            return total + chunk.reduce((chunkTotal, region) => {
              return chunkTotal + (reportData[region]?.total || 0);
            }, 0);
          }, 0);
          
          return (
            <div className="hidden" data-total={totalEntrepreneurs}></div>
          );
        })()}
        
        {regionChunks.map((regionChunk, chunkIndex) => (
          <div key={`chunk-${chunkIndex}`} className="mb-8">
            {/* Header Row */}
            <div className="flex md:flex-row items-start gap-1 md:gap-2">
              <div className="w-[60px] md:w-[220px]">
                <p className="h-4 md:h-7 text-[#152C24] rounded-md text-[4px] md:text-[16px] font-bold">AGRICULTURAL SMMEs</p>
              </div>
              <p className="h-4 md:h-7 text-[#152C24] rounded-md text-[4px] md:text-[16px] font-bold">TOTAL</p>
    
              <div className="grid grid-cols-9 md:grid-cols-9 md:gap-[10px] gap-[2px] flex-1 overflow-x-auto">
                {regionChunk.map((region, i) => (
                  <div key={i} className="text-[4px] md:text-[14px] rounded-[5px] text-black font-extrabold px-1 text-center md:w-[100px] ">
                    {region}
                  </div>
                ))}
              </div>
            </div>
            
            {/* Section Title */}
            <p className="text-[#152C24] font-bold mb-1 md:mb-2 text-[6px] md:text-[14px]">TOTAL</p>
            <div className="mt-1 md:mt-2">
              <div className='md:h-[2px] h-[1px] bg-black'></div>
    
              {/* Entrepreneurs Row */}
              <div className="overflow-x-auto">
                <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[120px_repeat(9,1fr)] gap-y-1 gap-x-1 md:gap-x-2 mt-1 md:mt-3">
                  <div className="flex items-center gap-1 md:w-[300px]">
                    <div className="text-[4px] md:text-[14px] text-black w-[60px] md:w-[180px] font-bold leading-tight">
                      Agricultural Entrepreneurs
                    </div>
                    <div className="md:w-[34px] w-[10px] h-[10px] md:h-[34px] bg-[#FFBD26] rounded-full cursor-pointer"/>
                    <div className="h-4 md:h-7 text-[#152C24] md:ml-[30px] ml-[5px] font-bold rounded-md text-[4px] md:text-[14px] flex items-center justify-center">
                      {getTotalForAllRegions(null, 'total', regionChunk)}
                    </div>
                  </div>
                  {regionChunk.map((region, j) => (
                    <div
                      key={`total-${j}`}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[4px] md:text-[16px] flex items-center justify-center font-bold"
                    >
                      {getCount(region, null, 'total')}
                    </div>
                  ))}
                </div>
              </div>
            </div>
    
            {/* Land Size Row */}
            <div className="mt-1 md:mt-2">
              <div className="overflow-x-auto">
                <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[120px_repeat(9,1fr)] gap-y-1 gap-x-1 md:gap-x-2">
                  <div className="flex items-center ">
                    <div className="text-[4px] md:text-[14px] w-[65px] md:w-[150px] text-black font-bold leading-tight">
                      Land (Ha)
                    </div>
                    <div className="md:w-[34px] w-[10px] h-[10px] md:h-[34px] bg-[#2E453D] rounded-full cursor-pointer"/>
                    <div className="h-4 md:h-7 md:ml-0 ml-2 text-[#152C24] rounded-md font-bold text-[4px] md:text-[14px] flex items-center justify-center">
                      {regionChunk.reduce((total, region) => {
                        return total + (reportData[region]?.landSizeTotal || 0);
                      }, 0)}
                    </div>
                  </div>
                  {regionChunk.map((region) => (
                    <div 
                      key={`total-${region}`}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[4px] md:text-[16px] flex items-center justify-center font-normal"
                    >
                      {reportData[region]?.landSizeTotal || 0}
                    </div>
                  ))}
                </div>
              </div>
            </div>
    
            {/* Production Cost Row */}
            <div className="mt-2 md:mt-8">
              <div className="overflow-x-auto">
                <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[120px_repeat(9,1fr)] gap-y-1 gap-x-1 md:gap-x-2">
                  <div className="flex items-center gap-1">
                    <div className="text-[4px] md:text-[14px] text-black w-[60px] md:w-[120px] font-bold leading-tight">
                      Production Cost
                    </div>
                    <div className="md:w-[34px] w-[10px] h-[10px] md:h-[34px]  bg-[#9FAFAF] rounded-full cursor-pointer"/>
                    <div className="h-4 md:h-7 text-[#152C24] rounded-md md:ml-0 ml-[5px]  font-bold text-[4px] md:text-[14px] flex items-center justify-center">
                      {getTotalForAllRegions(null, 'total', regionChunk)}
                    </div>
                  </div>
                  {regionChunk.map((region, j) => (
                    <div
                      key={`total-${j}`}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[4px] md:text-[16px] flex items-center justify-center font-normal"
                    >
                      {getCount(region, null, 'total')}
                    </div>
                  ))}
                </div>
              </div>
            </div>
    
            {/* Revenue Row */}
            <div className="mt-1 md:mt-2">
              <div className="overflow-x-auto">
                <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[120px_repeat(9,1fr)] gap-y-1 gap-x-1 md:gap-x-2">
                  <div className="flex items-center gap-1">
                    <div className="text-[4px] md:text-[14px] text-black w-[60px] md:w-[120px] font-bold leading-tight">
                      Revenue
                    </div>
                    <div className="md:w-[34px] w-[10px] h-[10px] md:h-[34px] bg-[#CFD7D7] rounded-full cursor-pointer"/>
                    <div className="h-4 md:h-7 text-[#152C24] rounded-md md:ml-0 ml-[4px] text-[4px] md:text-[14px] flex items-center justify-center font-bold">
                      {getTotalForAllRegions(null, 'total', regionChunk)}
                    </div>
                  </div>
                  {regionChunk.map((region, j) => (
                    <div
                      key={`total-${j}`}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[4px] md:text-[16px] flex items-center justify-center font-normal"
                    >
                      {getCount(region, null, 'total')}
                    </div>
                  ))}
                </div>
              </div>
            </div>
    
            {/* Enterprise Section */}
          
          </div>
        ))}
      </div>
      );
    };
    // Register chart.js components
const SMMEsOptions = [
  {
    "heading": "Smallholder Commercial Farms",
    "items": [
      {
        "label": "Small-scale farms operating for profit. Use improved inputs, some mechanization, and sell surplus to local markets. Often family-run but may hire seasonal labor. Example: A 5-hectare maize farm using hybrid seeds and selling to a local mill.",
        "value": "ESC"
      }
    ]
  },
  {
    "heading": "Medium-Scale Farms",
    "items": [
      {
        "label": "Larger landholding than smallholders (e.g., 10–100 hectares). Often mechanized and more capitalized. Supply supermarkets, processors, or export markets. Example: A 50-hectare rice farm with irrigation and a tractor, selling to a national rice brand.",
        "value": "EMS"
      }
    ]
  },
  {
    "heading": "Farmer Cooperatives / Producer Organizations",
    "items": [
      {
        "label": "Groups of farmers who pool resources to gain market power. May own equipment, storage, or transport collectively. Can register as SMEs and operate commercially. Example: A cooperative of 100 tomato farmers owning a cold storage unit.",
        "value": "EFC"
      }
    ]
  },
  {
    "heading": "Contract Farming SMEs",
    "items": [
      {
        "label": "Farmers or farm groups under formal agreements to supply crops/livestock to processors or exporters. Often receive inputs and training from buyers. Example: Poultry farmers supplying eggs to a food company under a contract.",
        "value": "ECF"
      }
    ]
  },
  {
    "heading": "Niche or Specialized Farms",
    "items": [
      {
        "label": "Farms focused on high-value or specialized production: Organic farms, Horticulture farms (vegetables, flowers, herbs), Aquaculture enterprises, Livestock or poultry SMEs, Beekeeping and honey production. Example: A small farm producing organic herbs for export.",
        "value": "ENS"
      }
    ]
  },
  {
    "heading": "Agri-Entrepreneurs with Integrated Operations",
    "items": [
      {
        "label": "These SMEs farm and also manage part of the value chain, such as: On-farm processing (e.g., dairy to yogurt), Direct-to-consumer sales (farm shops, online orders). Example: A mushroom farmer selling pre-packed mushrooms to urban grocers.",
        "value": "EAE"
      }
    ]
  },
  {
    "heading": "Youth or Women-led Farming Startups",
    "items": [
      {
        "label": "Often tech-savvy and innovative. Use climate-smart or digital farming tools. May focus on urban/peri-urban agriculture. Example: A woman-led hydroponic vegetable farm near a city.",
        "value": "EYW"
      }
    ]
  },
]
    const languageOptions = [
      "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"
     ];
   
     const purposeOptions = [
       "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", 
     ];
   
     const categoryOptions = [
     "2025","2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"
     ];
const Contract2th = () => {
  
  const renderButtonWithIcon = (text, bgColor, iconColor, isLarge = false) => {
    const bgColorClasses = {
      "#152C24": "bg-[#152C24]",
      "#2E453D": "bg-[#2E453D]",
      "#FDBB26": "bg-[#FDBB26]",
    };

    const iconColorClasses = {
      "#152C24": "bg-[#152C24]",
      "#EEB527": "bg-[#EEB527]",
      "#FDBB26": "bg-[#FDBB26]",
    };

    return (
      <div className="flex items-center">
        <div className={`${bgColorClasses[bgColor]} text-white md:text-[16px] text-[5px] px-2 md:px-4 ${
          isLarge ? "md:py-[14px] py-[3px]" : "md:py-[14px] py-[3px]"
        } md:rounded-l-md rounded-l-md font-bold md:w-[300px] whitespace-nowrap flex items-center h-full`}>
          {text}
        </div>
        
        <div className={`${iconColorClasses[iconColor]} hidden md:flex items-center md:py-2  justify-center md:w-[57px] md:h-[52px] rounded-r-md`}>
          <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752695779/Expand_down_kysnx1.png"
            alt="Expand"
            className="w-[20px] h-[6px] md:h-[40px] md:w-[55px]  object-contain"
          />
        </div>
        
        <div className={`${iconColorClasses[iconColor]} md:hidden flex items-center justify-center w-[20px]  h-[14px] rounded-r-md`}>
          <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752695779/Expand_down_kysnx1.png"
            alt="Expand"
            className="w-[20px] h-[6px]  object-contain"
          />
        </div>
      </div>
    );
  };

  const { selectedCountry } = useCountry();
  const [selectedService, setSelectedService] = useState(null);
  const [reportSelections, setReportSelections] = useState({
      COUNTRY: "-",
      REGION: "-",
      DISTRICT: "-",
      MUNICIPALITY: "-",
      SMMEs: "-",
      "VALUE CHAIN": "-",
      PROJECT: "-",
      "USER TYPE": "-"
  });

  const dropdownOptions = [
      { id: 1, name: "Option 1", value: "opt1" },
      { id: 2, name: "Option 2", value: "opt2" },
      { id: 3, name: "Option 3", value: "opt3" },
  ];
  const [dropdownSelections, setDropdownSelections] = useState({
      user_type: "English", // Default to English
      user_purpose: "View reports",
      user_category: "All categories"
    });
  const handleDropdownChange = (type, value) => {
    setDropdownSelections(prev => ({
      ...prev,
      [type]: value
    }));
  };

  const handleDropdownSelect = (option) => {
      console.log("Selected:", option);
  };
  const handleReportDropdownChange = (type, value) => {
    setReportSelections(prev => {
      const newSelections = {
        ...prev,
        [type]: value
      };
      
      if (type === 'COUNTRY') {
        newSelections.REGION = "-";
        newSelections.DISTRICT = "-";
        newSelections.MUNICIPALITY = "-";
      }
      
      return newSelections;
    });
  };
  const SMMEsOptions = [
    {
      "heading": "Smallholder Commercial Farms",
      "items": [
        {
          "label": "Small-scale farms operating for profit. Use improved inputs, some mechanization, and sell surplus to local markets. Often family-run but may hire seasonal labor. Example: A 5-hectare maize farm using hybrid seeds and selling to a local mill.",
          "value": "ESC"
        }
      ]
    },
    {
      "heading": "Medium-Scale Farms",
      "items": [
        {
          "label": "Larger landholding than smallholders (e.g., 10–100 hectares). Often mechanized and more capitalized. Supply supermarkets, processors, or export markets. Example: A 50-hectare rice farm with irrigation and a tractor, selling to a national rice brand.",
          "value": "EMS"
        }
      ]
    },
    {
      "heading": "Farmer Cooperatives / Producer Organizations",
      "items": [
        {
          "label": "Groups of farmers who pool resources to gain market power. May own equipment, storage, or transport collectively. Can register as SMEs and operate commercially. Example: A cooperative of 100 tomato farmers owning a cold storage unit.",
          "value": "EFC"
        }
      ]
    },
    {
      "heading": "Contract Farming SMEs",
      "items": [
        {
          "label": "Farmers or farm groups under formal agreements to supply crops/livestock to processors or exporters. Often receive inputs and training from buyers. Example: Poultry farmers supplying eggs to a food company under a contract.",
          "value": "ECF"
        }
      ]
    },
    {
      "heading": "Niche or Specialized Farms",
      "items": [
        {
          "label": "Farms focused on high-value or specialized production: Organic farms, Horticulture farms (vegetables, flowers, herbs), Aquaculture enterprises, Livestock or poultry SMEs, Beekeeping and honey production. Example: A small farm producing organic herbs for export.",
          "value": "ENS"
        }
      ]
    },
    {
      "heading": "Agri-Entrepreneurs with Integrated Operations",
      "items": [
        {
          "label": "These SMEs farm and also manage part of the value chain, such as: On-farm processing (e.g., dairy to yogurt), Direct-to-consumer sales (farm shops, online orders). Example: A mushroom farmer selling pre-packed mushrooms to urban grocers.",
          "value": "EAE"
        }
      ]
    },
    {
      "heading": "Youth or Women-led Farming Startups",
      "items": [
        {
          "label": "Often tech-savvy and innovative. Use climate-smart or digital farming tools. May focus on urban/peri-urban agriculture. Example: A woman-led hydroponic vegetable farm near a city.",
          "value": "EYW"
        }
      ]
    },
  ]
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [datePickerFor, setDatePickerFor] = useState(null);
    const [openingDate, setOpeningDate] = useState('');
    const [closingDate, setClosingDate] = useState('');
  const handleDateClick = (dateType) => {
    setDatePickerFor(dateType);
    setShowDatePicker(true);
  };
  const [agreed, setAgreed] = useState(false);
    const [enterpriseTotal, setEnterpriseTotal] = useState(0);
    const handleDateApply = ({ date }) => {
      if (datePickerFor === 'opening') {
        setOpeningDate(date);
      } else {
        setClosingDate(date);
      }
    }; 
  return (
   <div className='bg-white'>
          <div className=' md:pt-6 pt-2 md:pb-5 pb-2'>
            <div className="md:px-24 px-4">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-2 md:gap-0">
                  <h2 className="text-[14px] md:text-[36px] capitalize text-[#152C24] font-bold">
                      <span className="text-[#979797] capitalize">SERVICES | </span>{selectedCountry?.name || 'South Africa'}
                  </h2>
                  <div className="w-full md:w-auto">
                      <h1 className="text-[10px] md:text-[20px] font-extrabold md:mb-2">USER NUMBER</h1>
                      <div className="flex w-full md:w-fit">
                          <button
                              className={`w-full md:w-[250px] h-[25px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-2 rounded-l-[5px]`}>
                              <input className="text-[10px] md:text-[18px] md:px-2 bg-transparent outline-none placeholder-white w-full" placeholder="XXXXXXXXX"/>
                          </button>
                          <div
                              className="w-[25px] h-[25px] md:h-[53px] md:w-[50px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-1 z-30 cursor-pointer"
                          >
                              <img
                                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
                                  alt="expand"
                                  className="w-3 h-3 md:w-6 md:h-[24px]"
                              />
                          </div>
                      </div>
                      <p className="text-[8px] md:text-[14px] font-normal mt-1 text-black">
                          Insert ID Number
                      </p>
                  </div>
              </div>
              <ReportsSection
        values={reportSelections}
        onChange={handleReportDropdownChange}
      />
              {/* Search Section */}
              <div className="flex md:flex-row items-center w-full md:mb-4 md:mt-6 my-3 gap-2 md:gap-12">
              <div>
             <h1 className="md:text-[32px] font-bold text-[10px] text-[#152C24]"  >Services</h1>
           <Dropdown4
                      type="SERVICES" 
                      value={selectedService} 
                      onSelect={(option) => setSelectedService(option)}
                  />
                  
             </div>
                  <div className="flex-1 w-full relative md:mt-10">
                      <input
                          placeholder="Search"
                          type="text"
                          className="w-full h-[30px] md:h-[61px] text-[#979797] text-[10px] md:text-[16px] font-semibold p-2 pr-8 md:p-3 md:px-6 border border-[#C4C4C4] rounded-md focus:outline-none focus:ring-2 focus:ring-green-600"
                      />
                      <img
                          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744490602/Search_k7vxkr.png"
                          alt="Search Icon"
                          className="w-[14px] h-[14px] md:h-[24px] md:w-[24px] absolute right-3 top-1/2 transform -translate-y-1/2"
                      />
                  </div>
              </div>
              
              {/* Hero Banner */}
              <h2 className="text-[14px] md:text-[36px] capitalize text-[#152C24] font-bold">
                  Contracts
              </h2>
              
              <div className="relative w-full h-[150px] md:h-[650px] mt-2 md:mt-0">
                  <img
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1752266476/image_1844_qjhe0y.png"
                      alt="Securing Agriculture in Namibia"
                      className="w-full h-full object-cover md:rounded-lg rounded-md transition-opacity duration-500"
                  />
              </div>
              
              {/* Content Section */}
              <h2 className="text-[14px] md:text-[36px] md:mt-6  md:mb-2 mb-0 mt-3 capitalize text-[#152C24] font-bold">
              Contracts
              </h2>
              <Dropdown1
                      type="SERVICES" 
                      value={selectedService} 
                      onSelect={(option) => setSelectedService(option)}
                  />
                         <div className="flex items-center justify-between mt-4">
                         <h2 className="text-[14px] md:text-[36px] md:mt-6 mt-3 capitalize text-[#152C24] font-bold">
                    <span className="text-[#979797] capitalize">Contracts | </span>African Marmalade
                </h2>
                <div className="md:w-[316px] w-[80px] h-[20px] md:h-[51px] bg-[#2E453D] rounded-[5px] flex justify-end">
      <button className="md:w-[150px] w-[50px] h-full bg-[#2E453D] text-white text-[8px] md:text-[20px] font-bold rounded-[5px] z-10">
        Farmers
      </button>
      <button className="md:w-[150px] w-[50px] text-[8px] font-bold md:text-[20px] h-full bg-[#152C24] text-white rounded-[5px] z-20">
        {enterpriseTotal.toLocaleString()}
      </button>
    </div>
                         </div>
                         <h2 className="text-[14px] md:text-[36px] md:mt-6 mt-3 capitalize text-[black] font-bold">
              About 
              </h2>
                         <h2 className="text-[14px] md:text-[36px] md:mt-7 mt-3 capitalize text-[black] font-bold">
                         African Marmalade:
</h2>
<p className='text-[10px] md:text-[32px] font-medium md:mb-10 mb-4'>
 is a South African farming enterprise founded by Siphiwe Sithole that specializes in indigenous crops and fresh produce aggregation.
</p>

<div className="mt-4">
  <p className='text-[10px] md:text-[32px] font-medium'>
    <strong>Farmer Network:</strong> Aggregates produce from small-scale farmers, especially women, across Gauteng and beyond.
  </p>
</div>

<div className="mt-4">
  <p className='text-[10px] md:text-[32px] font-medium'>
    <strong>Market Access:</strong> Uses the OneFarm Share platform to connect farmers to markets, offering fair pricing, logistics, and payment support.
  </p>
</div>

<div className="mt-4">
  <p className='text-[10px] md:text-[32px] font-medium'>
    <strong>Indigenous Focus:</strong> Preserves and promotes African crops like millet, cowpeas, and amaranth.
  </p>
</div>

<div className="mt-4 md:mb-10 mb-4">
  <p className='text-[10px] md:text-[32px] font-medium'>
    <strong>Food Security:</strong> Supplies large quantities of produce for food relief, retailers, and chefs, while supporting community income.
  </p>
</div>
            </div>
              
              {/* Farmers Grid */}
              <div>
      
              <div>
        <div >
 <div className="md:px-20 px-4">
 <div className="flex justify-between items-center">
    <h2 className="md:text-[36px] text-[10px] text-[#152C24] font-bold">
      <span className="text-[#979797]">AGGREGATOR | </span>ALL
    </h2>
   <div>
   <h1 className="md:text-[20px] text-[8px] font-bold mb-1">FARMING</h1>
   <Dropdown3 
    type="CROPS"  // Add this prop to specify which options to show
    value={selectedService} 
    onSelect={(option) => setSelectedService(option)}
/>
<h1 className="md:text-[16px] text-[6px] font-regular mt-1">Select produce</h1>

   </div>
    
  </div>
  <div className="flex justify-end items-end md:mt-5 mt-2">
    <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751800571/image_1814_z9vymo.png" alt="/" className="w-[40px] h-[40px] md:w-[128px] md:h-[128px]"/>
  </div>
  {/* Three dropdowns tightly packed on the right */}
  <div className="flex justify-between">
<div className="flex md:gap-4 gap-2 items-center">
<div className="flex md:space-x-4 space-x-1 items-center cursor-pointer" 
    onClick={() => handleDateClick('opening')}>
    <h1 className="md:text-[20px] text-[6px] font-semibold">
      Opening Date {openingDate && `: ${openingDate}`}
    </h1>
    <img 
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745016720/image_1686_xak1hv.png" 
      alt="calendar" 
      className="md:w-[22px] md:h-[22px] h-[10px]" 
    />
  </div>
  <div className="flex md:space-x-4 space-x-1 items-center cursor-pointer"
    onClick={() => handleDateClick('closing')}>
    <h1 className="md:text-[20px] text-[6px] font-semibold">
      Closing Date {closingDate && `: ${closingDate}`}
    </h1>
    <img 
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745016720/image_1686_xak1hv.png" 
      alt="calendar" 
      className="md:w-[22px] md:h-[22px] h-[10px]" 
    />
  </div>

</div>
  {showDatePicker && (
    <DateRangePopup
      onClose={() => setShowDatePicker(false)}
      onApply={handleDateApply}
      dateType={datePickerFor}
    />
  )}


    <div className="flex gap-2">
      <Dropdown2
        label="WEEKLY"
        items={languageOptions}
        type="FACILITATOR"
        isProjectDropdown={false}
        onChange={(type, value) => handleDropdownChange('user_type', value)}
        className="border-r-0 rounded-r-none"
      />
      
      <Dropdown2
        label="MONTHLY"
        items={purposeOptions}
        type="PURPOSE"
        isProjectDropdown={false}
        onChange={(type, value) => handleDropdownChange('user_purpose', value)}
        className="border-l-0 border-r-0 rounded-none"
      />
      
      <Dropdown2
        label="YEARLY"
        items={categoryOptions}
        type="CATEGORY"
        isProjectDropdown={false}
        onChange={(type, value) => handleDropdownChange('user_category', value)}
        className="border-l-0 rounded-l-none"
      />
    </div>
  </div>
  
 </div>
  <div className="md:flex hidden">
    <Chart/>
  </div>
</div>
          <div className="md:hidden flex">
            <ChartMobile/>
          </div>
          
          <div className="md:px-24 px-4  md:-mt-40">
      <div className="md:flex hidden">
      <EnterpriseSection 
              regions={Object.keys(getRegionMap(reportSelections.COUNTRY))} 
              country={reportSelections.COUNTRY}
              reportSelections={reportSelections}
              onTotalCalculated={setEnterpriseTotal}
            />
      </div>
            <div className="md:hidden flex">
            <EnterpriseSection1 
              regions={Object.keys(getRegionMap(reportSelections.COUNTRY))} 
              country={reportSelections.COUNTRY}
              reportSelections={reportSelections}
              onTotalCalculated={setEnterpriseTotal}
            />
            </div>
            
            
         
          
          </div>
        </div>
                  {/* OFFTAKE PARTNERSHIP AGREEMENT */}
                  <div className="flex justify-between md:mt-8 mt-4 md:px-24 pr-4">
                  <a href="/ContractDocument">
       <div>
            {renderButtonWithIcon("REQUEST TO JOIN", "#152C24", "#EEB527", true)}
          </div>
       </a>
       <a href="/Contract3">
       <div>
            {renderButtonWithIcon("CONSTITUTION", "#152C24", "#EEB527", true)}
          </div>
       </a>
        <a href="/ContractDocument">
       <div>
            {renderButtonWithIcon("DOWNLOAD REPORTS", "#152C24", "#EEB527", true)}
          </div>
       </a>
       
        </div>
              </div>
              
          
          </div>
      </div>
  );
}

export default Contract2th;